export const familiesFriends = {
  en: {
    // Existing keys
    tabFamily: 'Family',
    tabFriends: 'Friends',
    tabInvitations: 'Invitations',
    actionAddFamilyMember: 'Add Family Member',
    actionAddFriend: 'Add Friend',
    actionSendInvitation: 'Send Invitation',
    actionAccept: 'Accept',
    actionDecline: 'Decline',
    actionRemove: 'Remove',
    actionSearch: 'Search',
    buttonOk: 'OK',
    placeholderEmailUsername: 'Enter email or username',
    labelFamilyMemberName: 'Family Member Name',
    labelFriendName: "Friend's Name",
    messageNoFamilyMembers: 'No family members found.',
    messageNoFriends: 'No friends found.',
    messageNoPendingInvitations: 'No pending invitations.',
    messageInvitationSent: 'Invitation sent to {{name}}.',
    messageInvitationAccepted: 'Invitation accepted from {{name}}.',
    messageInvitationDeclined: 'Invitation declined from {{name}}.',
    messageRemovedSuccessfully: 'Successfully removed {{name}}.',
    messageConfirmRemove: 'Are you sure you want to remove {{name}}?',
    titleCreateFamily: 'Create Family',
    placeholderFamilyName: 'Family Name',
    buttonCreate: 'Create',
    buttonCancel: 'Cancel',
    errorFamilyNameRequired: 'Family name is required.',
    errorFamilyLimit: 'You can belong to up to 3 families. Please leave one before creating a new family.',
    titleCreateFriendsGroup: 'Create Friends Group',
    placeholderGroupName: 'Group Name',
    errorGroupNameRequired: 'Group name is required.',
    titleInviteMember: 'Invite Member',
    labelShareInvite: 'Share this invite:',
    buttonCopyLink: 'Copy Link',
    buttonShare: 'Share',
    buttonShareWhatsApp: 'Share via WhatsApp',
    labelInviteCode: 'Or use invite code:',
    buttonCopyCode: 'Copy Code',
    buttonDone: 'Done',
    labelPendingInvites: 'Pending Invites:',
    titleJoinByCode: 'Join Family by Invite Code',
    placeholderInviteCode: 'Enter invite code...',
    buttonJoinFamily: 'Join Family',
    buttonJoining: 'Joining...',
    titleFamilyMembers: 'Family Members',
    roleOwner: '⭐ Owner',
    roleAdmin: '⭐ Admin',
    roleMember: 'Member',
    buttonMakeAdmin: 'Make Admin',
    buttonClose: 'Close',
    titleFriendsMembers: 'Friends Members',
    tabFamilyHub: 'Family Hub',
    tabFriendsHub: 'Friends Hub',
    loadingFamilyHub: 'Loading Family Hub...',
    loadingFriendsHub: 'Loading Friends Hub...',
    errorLoadingFamily: 'Error loading family data',
    errorLoadingFriends: 'Error loading friends data',
    buttonRetry: 'Retry',
    errorLoadingFamilyHub: 'Error loading family hub',
    errorLoadingFriendsHub: 'Error loading friends hub',
    
    // New keys for GroupsHub internationalization
    headerTitle: 'CONNECT & GROW TOGETHER',
    headerSubtitle: 'Play privately with family and friends you already know',
    loadingFamilyAndFriendsHub: 'Loading Family and Friends Hub',
    emptyStateNotInFamily: 'You are not in a family yet.',
    buttonCreateFamily: 'Create Family',
    buttonJoinByInviteCode: 'Join by Invite Code',
    buttonViewInvitations: 'View Invitations ({{count}})',
    sectionTitlePendingInvitations: 'Pending Invitations',
    buttonCreateFamilyOrFriendsGroup: 'Create Family or Friends Group',
    alertSuccessInvitationAccepted: 'Invitation accepted!',
    alertSuccessInvitationRejected: 'Invitation rejected.',
    alertErrorInvitationResponse: 'Failed to respond to invitation.',
    shareInviteMessage: 'Join my family or friends group on Kingdom Bible Quiz! Tap this link: {{url}}',
    alertErrorShareInvite: 'Failed to share invite link.',
    alertSuccessCodeCopied: 'Family code copied to clipboard.',
    alertSuccessFriendsCodeCopied: 'Friends group code copied to clipboard.',
    alertErrorCopyCode: 'Could not copy code.',
    alertSuccessLeftFamily: 'You have left the family.',
    alertSuccessLeftFriendsGroup: 'You have left the friends group.',
    alertErrorLeaveFamily: 'Failed to leave family.',
    alertErrorLeaveFriendsGroup: 'Failed to leave friends group.',
    premiumCardFamilyLeaderboard: 'Family Leaderboard',
    premiumCardFamilyLeaderboardSubtitle: 'Track your family\'s spiritual growth together',
    premiumCardFriendsLeaderboard: 'Friends Leaderboard',
    premiumCardFriendsLeaderboardSubtitle: 'Compete and grow together with your friends',
    premiumCardComingSoon: 'Coming Soon',
    alertSuccessMemberPromoted: 'Member promoted to admin!',
    alertErrorPromoteMember: 'Failed to promote member.',
    liveScreenNoticeText: 'Looking for churches or large teams? Check out the Live Screen tab for community events and large group features.',
    liveScreenNoticeLink: 'Live Screen',
    
    // Family/Friends Group Cards
    membersLabel: 'Members',
    statusLabel: 'Status',
    activeStatus: 'Active',
    shareLink: '🔗 Share Link',
    copyCode: '📋 Copy Code',
    viewMembers: '👥 View Members',
    invitationFromTo: 'Invitation from {{sender}} to join {{group}}',
    unknown: 'Unknown',
    group: 'group',
    titleInviteCode: 'Invite Code',
    messageShareCodeWithFriends: 'Share this code with friends: {{code}}',
    leaveGroup: 'Leave Group',
    featureNotImplemented: 'This feature is not implemented yet.',
    leaveFamily: '🚪 Leave Family',
    enterFamilyLobby: 'Enter Family Lobby',
    enterFriendsLobby: 'Enter Friends Lobby',
    buttonJoinWithCode: 'Join with Code',
    sectionTitleYourFriendsGroups: 'Your Friends Groups',
    emptyFriendsGroupsTitle: 'No Friends Groups Yet',
    emptyFriendsGroupsSubtitle: 'Create or join a friends group to start playing Bible quizzes together!',
    // Together tab
    togetherSubtitle: 'Play and grow with family and friends',
    familyBibleQuiz: 'Family Bible Quiz',
    familyQuizSubtitle: 'Learn Scripture together as a family',
    startQuiz: 'Start Quiz',
    inviteFamily: 'Invite Family',
    signInToJoinFamily: 'Sign in to create or join a family group.',
    premiumGroupGateMessage: 'Join any group for free with an invite code. Create and host your own with Premium.',
    familyInviteMessage: 'Join my family "{{name}}" on Kingdom Bible Quiz! Use code {{code}} or tap: {{url}}',
    playAnotherQuizTitle: 'Play Another Quiz?',
    playAnotherQuizSubtitle: 'Would you like to start a new game with the same group?',
    playAnotherQuizReturnLobby: 'All players will return to the {{roomType}} lobby',
    playAnotherQuizResultsSaved: 'Current game results are saved',
    playAnotherQuizFreshStart: 'New game = fresh start for everyone',
    playAnotherQuizSettingUp: 'Setting up...',
    playAnotherQuizConfirm: 'Yes, Start New Game',
    playAnotherQuizDecline: 'No, Return to Lobby',
    playAnotherQuizError: 'Failed to start a new game. Please try again.',
    inviteCopiedTitle: 'Copied!',
    inviteLinkCopied: 'Invitation link copied to clipboard',
    inviteCodeCopied: 'Join code copied to clipboard',
    inviteCopyLinkError: 'Failed to copy link',
    inviteCopyCodeError: 'Failed to copy code',
    inviteShareError: 'Failed to share invitation',
    inviteShareRoomMessage: 'Come join our Kingdom Bible Quiz room for the next family and friends challenge. Use code {{code}} or open {{url}}',
    inviteShareEventMessage: 'This event link is for the separate church and large-group quiz experience: {{url}}',
    inviteShareTitle: 'Join {{title}}',
    roomInviteEyebrow: 'Family & Friends Quiz',
    roomInviteTitle: 'You have been invited to a quiz room',
    roomInviteSubtitle: 'Join the room in the app to play together, keep your progress in sync, and stay connected with your family and friends.',
    roomInviteCodeLabel: 'Room Code',
    roomInviteSignedInHint: 'You are signed in and ready to join this room.',
    roomInviteAuthHint: 'Create a free account or sign in to join this room and keep your multiplayer progress together.',
    roomInviteContinue: 'Join Quiz Room',
    roomInviteJoining: 'Joining room...',
    roomInviteSignIn: 'Sign in or create account',
    roomInviteWebHint: 'If you already have the app installed, this invite will open there automatically.',
    roomInviteInvalidTitle: 'Invite unavailable',
    roomInviteInvalidBody: 'This room invitation link is missing the details needed to join.',
    roomInviteJoinError: 'We could not join this room yet. Please try the room code again.',
    inviteHowToJoin: 'How to Join:',
    inviteScanQr: 'Scan this QR code with your camera',
    inviteEnterCode: 'Or enter join code: {{code}}',
    inviteTipsTitle: 'Sharing Tips:',
    inviteTipFriendsFamily: 'Share with family or friends you already know',
    inviteTipMessage: 'Send the link by text message or email',
    inviteTipCode: 'Use the join code if the link does not open directly',
    groupSelectorLoadError: 'Failed to load your family and friends groups. Please try again.',
    groupSelectorEmptyTitle: 'No Groups Found',
    groupSelectorEmptyBody: 'You are not in any family or friends groups yet.',
    groupSelectorSelect: 'Select Group',
    groupSelectorTitle: 'Select Group',
    groupTypeFamily: 'Family',
    groupTypeFriends: 'Friends',
    joinCodeRequired: 'Please enter a code or link.',
    joinFamilySuccess: 'You have joined the family!',
    joinFriendsSuccess: 'You have joined the friends group!',
    joinByCodeTitle: 'Join {{group}} by Invite Code',
    joinByCodeAction: 'Join {{group}}',
    invalidInviteCode: 'This invite code is invalid or has expired. Check the code and try again.',
  },
  es: {
    buttonOk: 'OK',
    buttonShare: 'Compartir',
    errorLoadingFriendsHub: 'Error al cargar el centro de amigos',
    invitationFromTo: 'Invitación de {{sender}} para unirte a {{group}}',
    unknown: 'Desconocido',
    group: 'grupo',
    titleInviteCode: 'Código de invitación',
    messageShareCodeWithFriends: 'Comparte este código con tus amigos: {{code}}',
    featureNotImplemented: 'Esta función aún no está disponible.',
    buttonJoinWithCode: 'Unirse con código',
    sectionTitleYourFriendsGroups: 'Tus grupos de amigos',
    emptyFriendsGroupsTitle: 'Aún no hay grupos de amigos',
    emptyFriendsGroupsSubtitle: '¡Crea o únete a un grupo de amigos para jugar quizzes bíblicos juntos!',
    inviteCopiedTitle: '¡Copiado!',
    inviteLinkCopied: 'Enlace de invitación copiado al portapapeles',
    inviteCodeCopied: 'Código para unirse copiado al portapapeles',
    inviteCopyLinkError: 'No se pudo copiar el enlace',
    inviteCopyCodeError: 'No se pudo copiar el código',
    inviteShareError: 'No se pudo compartir la invitación',
    inviteShareRoomMessage: 'Únete a nuestra sala de Kingdom Bible Quiz para el próximo reto en familia y con amigos. Usa el código {{code}} o abre {{url}}',
    inviteShareEventMessage: 'Este enlace de evento es para la experiencia de quiz separada para iglesias y grupos grandes: {{url}}',
    inviteShareTitle: 'Únete a {{title}}',
    roomInviteEyebrow: 'Quiz en familia y con amigos',
    roomInviteTitle: 'Te han invitado a una sala de quiz',
    roomInviteSubtitle: 'Únete a la sala en la app para jugar juntos, mantener tu progreso sincronizado y seguir conectado con tu familia y amigos.',
    roomInviteCodeLabel: 'Código de la sala',
    roomInviteSignedInHint: 'Has iniciado sesión y estás listo para unirte a esta sala.',
    roomInviteAuthHint: 'Crea una cuenta gratuita o inicia sesión para unirte a esta sala y conservar tu progreso multijugador.',
    roomInviteContinue: 'Unirse a la sala de quiz',
    roomInviteJoining: 'Uniéndose a la sala…',
    roomInviteSignIn: 'Iniciar sesión o crear cuenta',
    roomInviteWebHint: 'Si ya tienes la app instalada, esta invitación se abrirá allí automáticamente.',
    roomInviteInvalidTitle: 'Invitación no disponible',
    roomInviteInvalidBody: 'A este enlace de invitación le faltan los datos necesarios para unirse.',
    roomInviteJoinError: 'Aún no pudimos unirte a esta sala. Prueba de nuevo con el código de la sala.',
    inviteHowToJoin: 'Cómo unirse:',
    inviteScanQr: 'Escanea este código QR con tu cámara',
    inviteEnterCode: 'O introduce el código: {{code}}',
    inviteTipsTitle: 'Consejos para compartir:',
    inviteTipFriendsFamily: 'Comparte con familiares o amigos que ya conoces',
    inviteTipMessage: 'Envía el enlace por mensaje de texto o correo electrónico',
    inviteTipCode: 'Usa el código si el enlace no se abre directamente',
    groupSelectorLoadError: 'No se pudieron cargar tus grupos de familia y amigos. Inténtalo de nuevo.',
    groupSelectorEmptyTitle: 'No se encontraron grupos',
    groupSelectorEmptyBody: 'Aún no estás en ningún grupo de familia o amigos.',
    groupSelectorSelect: 'Seleccionar grupo',
    groupSelectorTitle: 'Seleccionar grupo',
    joinCodeRequired: 'Introduce un código o enlace.',
    joinFamilySuccess: '¡Te has unido a la familia!',
    joinFriendsSuccess: '¡Te has unido al grupo de amigos!',
    joinByCodeTitle: 'Unirse a {{group}} con código de invitación',
    joinByCodeAction: 'Unirse a {{group}}',
    playAnotherQuizConfirm: 'Sí, empezar nueva partida',
    playAnotherQuizDecline: 'No, volver a la sala',
    playAnotherQuizError: 'No se pudo iniciar una nueva partida. Inténtalo de nuevo.',
    playAnotherQuizFreshStart: 'Nueva partida = nuevo comienzo para todos',
    playAnotherQuizResultsSaved: 'Los resultados de la partida actual se guardan',
    playAnotherQuizReturnLobby: 'Todos los jugadores volverán a la sala de {{roomType}}',
    playAnotherQuizSettingUp: 'Preparando…',
    playAnotherQuizSubtitle: '¿Quieres empezar una nueva partida con el mismo grupo?',
    playAnotherQuizTitle: '¿Jugar otro quiz?',
    // Existing keys
    titleFamilyMembers: 'Miembros de la familia',
    roleOwner: '⭐ Propietario',
    roleAdmin: '⭐ Administrador',
    roleMember: 'Miembro',
    buttonMakeAdmin: 'Hacer admin',
    buttonClose: 'Cerrar',
    titleFriendsMembers: 'Miembros del grupo de amigos',
    tabFamilyHub: 'Centro de Familia',
    tabFriendsHub: 'Centro de Amigos',
    loadingFamilyHub: 'Cargando Centro de Familia...',
    loadingFriendsHub: 'Cargando Centro de Amigos...',
    errorLoadingFamily: 'Error al cargar datos de familia',
    errorLoadingFriends: 'Error al cargar datos de amigos',
    buttonRetry: 'Reintentar',
    tabFamily: 'Familia',
    tabFriends: 'Amigos',
    tabInvitations: 'Invitaciones',
    actionAddFamilyMember: 'Añadir Miembro Familiar',
    actionAddFriend: 'Añadir Amigo',
    actionSendInvitation: 'Enviar Invitación',
    actionAccept: 'Aceptar',
    actionDecline: 'Rechazar',
    actionRemove: 'Eliminar',
    actionSearch: 'Buscar',
    placeholderEmailUsername: 'Introducir correo electrónico o nombre de usuario',
    labelFamilyMemberName: 'Nombre del Miembro Familiar',
    labelFriendName: 'Nombre del Amigo',
    messageNoFamilyMembers: 'No se encontraron miembros familiares.',
    messageNoFriends: 'No se encontraron amigos.',
    messageNoPendingInvitations: 'No hay invitaciones pendientes.',
    messageInvitationSent: 'Invitación enviada a {{name}}.',
    messageInvitationAccepted: 'Invitación aceptada de {{name}}.',
    messageInvitationDeclined: 'Invitación rechazada de {{name}}.',
    messageRemovedSuccessfully: 'Eliminado {{name}} con éxito.',
    messageConfirmRemove: '¿Estás seguro de que quieres eliminar a {{name}}?',
    titleCreateFamily: 'Crear Familia',
    placeholderFamilyName: 'Nombre de la Familia',
    buttonCreate: 'Crear',
    buttonCancel: 'Cancelar',
    errorFamilyNameRequired: 'El nombre de la familia es obligatorio.',
    errorFamilyLimit: 'Puedes pertenecer a hasta 3 familias. Por favor deja una antes de crear una nueva familia.',
    titleCreateFriendsGroup: 'Crear Grupo de Amigos',
    placeholderGroupName: 'Nombre del Grupo',
    errorGroupNameRequired: 'El nombre del grupo es obligatorio.',
    titleInviteMember: 'Invitar Miembro',
    labelShareInvite: 'Comparte esta invitación:',
    buttonCopyLink: 'Copiar Enlace',
    buttonShareWhatsApp: 'Compartir por WhatsApp',
    labelInviteCode: 'O usa el código de invitación:',
    buttonCopyCode: 'Copiar Código',
    buttonDone: 'Hecho',
    labelPendingInvites: 'Invitaciones Pendientes:',
    titleJoinByCode: 'Unirse a Familia por Código de Invitación',
    placeholderInviteCode: 'Introducir código de invitación...',
    buttonJoinFamily: 'Unirse a Familia',
    buttonJoining: 'Uniéndose...',
    errorLoadingFamilyHub: 'Error al cargar centro de familia',
    
    // New keys for GroupsHub internationalization
    headerTitle: 'CONECTA Y CRECE JUNTOS',
    headerSubtitle: 'Construye tu comunidad espiritual con familia y amigos',
    loadingFamilyAndFriendsHub: 'Cargando Centro de Familia y Amigos',
    emptyStateNotInFamily: 'Aún no estás en una familia.',
    buttonCreateFamily: 'Crear Familia',
    buttonJoinByInviteCode: 'Unirse por Código de Invitación',
    buttonViewInvitations: 'Ver Invitaciones ({{count}})',
    sectionTitlePendingInvitations: 'Invitaciones Pendientes',
    buttonCreateFamilyOrFriendsGroup: 'Crear Familia o Grupo de Amigos',
    alertSuccessInvitationAccepted: '¡Invitación aceptada!',
    alertSuccessInvitationRejected: 'Invitación rechazada.',
    alertErrorInvitationResponse: 'Error al responder a la invitación.',
    shareInviteMessage: '¡Únete a mi familia o grupo de amigos en Kingdom Bible Quiz! Toca este enlace: {{url}}',
    alertErrorShareInvite: 'Error al compartir enlace de invitación.',
    alertSuccessCodeCopied: 'Código de familia copiado al portapapeles.',
    alertSuccessFriendsCodeCopied: 'Código de grupo de amigos copiado al portapapeles.',
    alertErrorCopyCode: 'No se pudo copiar el código.',
    alertSuccessLeftFamily: 'Has dejado la familia.',
    alertSuccessLeftFriendsGroup: 'Has dejado el grupo de amigos.',
    alertErrorLeaveFamily: 'Error al dejar la familia.',
    alertErrorLeaveFriendsGroup: 'Error al dejar el grupo de amigos.',
    premiumCardFamilyLeaderboard: 'Tabla de Clasificación Familiar',
    premiumCardFamilyLeaderboardSubtitle: 'Rastrea el crecimiento espiritual de tu familia juntos',
    premiumCardFriendsLeaderboard: 'Tabla de Clasificación de Amigos',
    premiumCardFriendsLeaderboardSubtitle: 'Compite y crece junto con tus amigos',
    premiumCardComingSoon: 'Próximamente',
    alertSuccessMemberPromoted: '¡Miembro promovido a administrador!',
    alertErrorPromoteMember: 'Error al promover miembro.',
    liveScreenNoticeText: '¿Buscas iglesias o equipos grandes? Echa un vistazo a la pestaña Pantalla en Vivo para eventos comunitarios y funciones de grupos grandes.',
    liveScreenNoticeLink: 'Pantalla en Vivo',
    
    // Family/Friends Group Cards
    groupTypeFamily: 'Familia',
    groupTypeFriends: 'Amigos',
    membersLabel: 'Miembros',
    statusLabel: 'Estado',
    activeStatus: 'Activo',
    shareLink: '🔗 Compartir Enlace',
    copyCode: '📋 Copiar Código',
    viewMembers: '👥 Ver Miembros',
    leaveFamily: '🚪 Dejar Familia',
    leaveGroup: '🚪 Dejar Grupo',
    enterFamilyLobby: 'Entrar al Lobby Familiar',
    enterFriendsLobby: 'Entrar al Lobby de Amigos',
    togetherSubtitle: 'Juega, comparte y crece con otros',
    familyBibleQuiz: 'Quiz Bíblico Familiar',
    familyQuizSubtitle: 'Aprende las Escrituras en familia',
    startQuiz: 'Iniciar Quiz',
    inviteFamily: 'Invitar Familia',
    signInToJoinFamily: 'Inicia sesión para crear o unirte a un grupo familiar.',
    premiumGroupGateMessage: 'Únete a cualquier grupo gratis con un código de invitación. Crea y organiza el tuyo con Premium.',
    familyInviteMessage: '¡Únete a mi familia "{{name}}" en Kingdom Bible Quiz! Usa el código {{code}} o toca: {{url}}',
    invalidInviteCode: 'Este código de invitación no es válido o ha caducado. Revísalo e inténtalo de nuevo.',
  },
  fr: {
    buttonOk: 'OK',
    buttonShare: 'Partager',
    errorLoadingFriendsHub: 'Erreur lors du chargement de l\'espace amis',
    invitationFromTo: 'Invitation de {{sender}} pour rejoindre {{group}}',
    unknown: 'Inconnu',
    group: 'groupe',
    titleInviteCode: 'Code d\'invitation',
    messageShareCodeWithFriends: 'Partagez ce code avec vos amis : {{code}}',
    featureNotImplemented: 'Cette fonctionnalité n\'est pas encore disponible.',
    buttonJoinWithCode: 'Rejoindre avec un code',
    sectionTitleYourFriendsGroups: 'Vos groupes d\'amis',
    emptyFriendsGroupsTitle: 'Aucun groupe d\'amis pour le moment',
    emptyFriendsGroupsSubtitle: 'Créez ou rejoignez un groupe d\'amis pour jouer ensemble aux quiz bibliques !',
    inviteCopiedTitle: 'Copié !',
    inviteLinkCopied: 'Lien d\'invitation copié dans le presse-papiers',
    inviteCodeCopied: 'Code d\'invitation copié dans le presse-papiers',
    inviteCopyLinkError: 'Impossible de copier le lien',
    inviteCopyCodeError: 'Impossible de copier le code',
    inviteShareError: 'Impossible de partager l\'invitation',
    inviteShareRoomMessage: 'Rejoignez notre salon Kingdom Bible Quiz pour le prochain défi en famille et entre amis. Utilisez le code {{code}} ou ouvrez {{url}}',
    inviteShareEventMessage: 'Ce lien d\'événement est destiné à l\'expérience de quiz distincte pour l\'église et les grands groupes : {{url}}',
    inviteShareTitle: 'Rejoindre {{title}}',
    roomInviteEyebrow: 'Quiz en famille et entre amis',
    roomInviteTitle: 'Vous êtes invité à un salon de quiz',
    roomInviteSubtitle: 'Rejoignez le salon dans l\'application pour jouer ensemble, synchroniser votre progression et rester en contact avec votre famille et vos amis.',
    roomInviteCodeLabel: 'Code du salon',
    roomInviteSignedInHint: 'Vous êtes connecté et prêt à rejoindre ce salon.',
    roomInviteAuthHint: 'Créez un compte gratuit ou connectez-vous pour rejoindre ce salon et garder votre progression multijoueur.',
    roomInviteContinue: 'Rejoindre le salon de quiz',
    roomInviteJoining: 'Connexion au salon…',
    roomInviteSignIn: 'Se connecter ou créer un compte',
    roomInviteWebHint: 'Si l\'application est déjà installée, cette invitation s\'y ouvrira automatiquement.',
    roomInviteInvalidTitle: 'Invitation indisponible',
    roomInviteInvalidBody: 'Il manque des informations dans ce lien d\'invitation pour rejoindre le salon.',
    roomInviteJoinError: 'Impossible de rejoindre ce salon pour le moment. Réessayez avec le code du salon.',
    inviteHowToJoin: 'Comment rejoindre :',
    inviteScanQr: 'Scannez ce code QR avec votre appareil photo',
    inviteEnterCode: 'Ou saisissez le code : {{code}}',
    inviteTipsTitle: 'Conseils de partage :',
    inviteTipFriendsFamily: 'Partagez avec des proches ou des amis que vous connaissez déjà',
    inviteTipMessage: 'Envoyez le lien par SMS ou par e-mail',
    inviteTipCode: 'Utilisez le code si le lien ne s\'ouvre pas directement',
    groupSelectorLoadError: 'Impossible de charger vos groupes famille et amis. Veuillez réessayer.',
    groupSelectorEmptyTitle: 'Aucun groupe trouvé',
    groupSelectorEmptyBody: 'Vous ne faites encore partie d\'aucun groupe famille ou amis.',
    groupSelectorSelect: 'Choisir un groupe',
    groupSelectorTitle: 'Choisir un groupe',
    groupTypeFamily: 'Famille',
    groupTypeFriends: 'Amis',
    joinCodeRequired: 'Veuillez saisir un code ou un lien.',
    joinFamilySuccess: 'Vous avez rejoint la famille !',
    joinFriendsSuccess: 'Vous avez rejoint le groupe d\'amis !',
    joinByCodeTitle: 'Rejoindre {{group}} avec un code d\'invitation',
    joinByCodeAction: 'Rejoindre {{group}}',
    playAnotherQuizConfirm: 'Oui, nouvelle partie',
    playAnotherQuizDecline: 'Non, retour au salon',
    playAnotherQuizError: 'Impossible de lancer une nouvelle partie. Veuillez réessayer.',
    playAnotherQuizFreshStart: 'Nouvelle partie = nouveau départ pour tous',
    playAnotherQuizResultsSaved: 'Les résultats de la partie en cours sont enregistrés',
    playAnotherQuizReturnLobby: 'Tous les joueurs retourneront au salon {{roomType}}',
    playAnotherQuizSettingUp: 'Préparation…',
    playAnotherQuizSubtitle: 'Voulez-vous lancer une nouvelle partie avec le même groupe ?',
    playAnotherQuizTitle: 'Rejouer un quiz ?',
    // French translations
    tabFamily: 'Famille',
    tabFriends: 'Amis',
    tabInvitations: 'Invitations',
    actionAddFamilyMember: 'Ajouter un Membre de la Famille',
    actionAddFriend: 'Ajouter un Ami',
    actionSendInvitation: 'Envoyer une Invitation',
    actionAccept: 'Accepter',
    actionDecline: 'Refuser',
    actionRemove: 'Supprimer',
    actionSearch: 'Rechercher',
    placeholderEmailUsername: 'Entrez l\'email ou le nom d\'utilisateur',
    labelFamilyMemberName: 'Nom du Membre de la Famille',
    labelFriendName: 'Nom de l\'Ami',
    messageNoFamilyMembers: 'Aucun membre de famille trouvé.',
    messageNoFriends: 'Aucun ami trouvé.',
    messageNoPendingInvitations: 'Aucune invitation en attente.',
    messageInvitationSent: 'Invitation envoyée à {{name}}.',
    messageInvitationAccepted: 'Invitation acceptée de {{name}}.',
    messageInvitationDeclined: 'Invitation refusée de {{name}}.',
    messageRemovedSuccessfully: '{{name}} supprimé avec succès.',
    messageConfirmRemove: 'Êtes-vous sûr de vouloir supprimer {{name}}?',
    titleCreateFamily: 'Créer une Famille',
    placeholderFamilyName: 'Nom de la Famille',
    buttonCreate: 'Créer',
    buttonCancel: 'Annuler',
    errorFamilyNameRequired: 'Le nom de famille est requis.',
    errorFamilyLimit: 'Vous pouvez appartenir à jusqu\'à 3 familles. Veuillez en quitter une avant d\'en créer une nouvelle.',
    titleCreateFriendsGroup: 'Créer un Groupe d\'Amis',
    placeholderGroupName: 'Nom du Groupe',
    errorGroupNameRequired: 'Le nom du groupe est requis.',
    titleInviteMember: 'Inviter un Membre',
    labelShareInvite: 'Partager cette invitation:',
    buttonCopyLink: 'Copier le Lien',
    buttonShareWhatsApp: 'Partager via WhatsApp',
    labelInviteCode: 'Ou utilisez le code d\'invitation:',
    buttonCopyCode: 'Copier le Code',
    buttonDone: 'Terminé',
    labelPendingInvites: 'Invitations en Attente:',
    titleJoinByCode: 'Rejoindre une Famille par Code d\'Invitation',
    placeholderInviteCode: 'Entrez le code d\'invitation...',
    buttonJoinFamily: 'Rejoindre la Famille',
    buttonJoining: 'Rejoindre...',
    titleFamilyMembers: 'Membres de la Famille',
    roleOwner: '⭐ Propriétaire',
    roleAdmin: '⭐ Administrateur',
    roleMember: 'Membre',
    buttonMakeAdmin: 'Rendre Administrateur',
    buttonClose: 'Fermer',
    titleFriendsMembers: 'Membres du Groupe d\'Amis',
    tabFamilyHub: 'Centre Famille',
    tabFriendsHub: 'Centre Amis',
    loadingFamilyHub: 'Chargement du Centre Famille...',
    loadingFriendsHub: 'Chargement du Centre Amis...',
    errorLoadingFamily: 'Erreur lors du chargement des données familiales',
    errorLoadingFriends: 'Erreur lors du chargement des données d\'amis',
    buttonRetry: 'Réessayer',
    errorLoadingFamilyHub: 'Erreur lors du chargement du centre famille',
    headerTitle: 'CONNECTEZ-VOUS ET GRANDISSEZ ENSEMBLE',
    headerSubtitle: 'Construisez votre communauté spirituelle avec famille et amis',
    loadingFamilyAndFriendsHub: 'Chargement du Centre Famille et Amis',
    emptyStateNotInFamily: 'Vous n\'êtes pas encore dans une famille.',
    buttonCreateFamily: 'Créer une Famille',
    buttonJoinByInviteCode: 'Rejoindre par Code d\'Invitation',
    buttonViewInvitations: 'Voir les Invitations ({{count}})',
    sectionTitlePendingInvitations: 'Invitations en Attente',
    buttonCreateFamilyOrFriendsGroup: 'Créer une Famille ou un Groupe d\'Amis',
    alertSuccessInvitationAccepted: 'Invitation acceptée!',
    alertSuccessInvitationRejected: 'Invitation refusée.',
    alertErrorInvitationResponse: 'Échec de la réponse à l\'invitation.',
    shareInviteMessage: 'Rejoignez ma famille ou mon groupe d\'amis sur Kingdom Bible Quiz! Cliquez sur ce lien: {{url}}',
    alertErrorShareInvite: 'Échec du partage du lien d\'invitation.',
    alertSuccessCodeCopied: 'Code famille copié dans le presse-papiers.',
    alertSuccessFriendsCodeCopied: 'Code du groupe d\'amis copié dans le presse-papiers.',
    alertErrorCopyCode: 'Impossible de copier le code.',
    alertSuccessLeftFamily: 'Vous avez quitté la famille.',
    alertSuccessLeftFriendsGroup: 'Vous avez quitté le groupe d\'amis.',
    alertErrorLeaveFamily: 'Échec de quitter la famille.',
    alertErrorLeaveFriendsGroup: 'Échec de quitter le groupe d\'amis.',
    premiumCardFamilyLeaderboard: 'Classement Familial',
    premiumCardFamilyLeaderboardSubtitle: 'Suivez la croissance spirituelle de votre famille ensemble',
    premiumCardFriendsLeaderboard: 'Classement des Amis',
    premiumCardFriendsLeaderboardSubtitle: 'Rivalité et croissance avec vos amis',
    premiumCardComingSoon: 'Bientôt Disponible',
    alertSuccessMemberPromoted: 'Membre promu administrateur!',
    alertErrorPromoteMember: 'Échec de la promotion du membre.',
    liveScreenNoticeText: 'Vous cherchez des églises ou de grandes équipes? Consultez l\'onglet Écran en Direct pour les événements communautaires et les fonctionnalités de grands groupes.',
    liveScreenNoticeLink: 'Écran en Direct',
    
    // Family/Friends Group Cards
    membersLabel: 'Membres',
    statusLabel: 'Statut',
    activeStatus: 'Actif',
    shareLink: '🔗 Partager le Lien',
    copyCode: '📋 Copier le Code',
    viewMembers: '👥 Voir les Membres',
    leaveFamily: '🚪 Quitter la Famille',
    leaveGroup: '🚪 Quitter le Groupe',
    enterFamilyLobby: 'Entrer dans le Lobby Familial',
    enterFriendsLobby: 'Entrer dans le Lobby des Amis',
    togetherSubtitle: 'Jouez, partagez et grandissez avec les autres',
    familyBibleQuiz: 'Quiz Biblique en Famille',
    familyQuizSubtitle: 'Apprenez les Écritures ensemble en famille',
    startQuiz: 'Commencer le Quiz',
    inviteFamily: 'Inviter la Famille',
    signInToJoinFamily: 'Connectez-vous pour créer ou rejoindre un groupe familial.',
    premiumGroupGateMessage: 'Rejoignez n\'importe quel groupe gratuitement avec un code d\'invitation. Créez et hébergez le vôtre avec Premium.',
    familyInviteMessage: 'Rejoins ma famille "{{name}}" sur Kingdom Bible Quiz ! Utilise le code {{code}} ou appuie sur : {{url}}',
    invalidInviteCode: 'Ce code d’invitation est invalide ou a expiré. Vérifiez-le et réessayez.',
  },
  de: {
    buttonOk: 'OK',
    buttonShare: 'Teilen',
    errorLoadingFriendsHub: 'Fehler beim Laden des Freundebereichs',
    invitationFromTo: 'Einladung von {{sender}}, {{group}} beizutreten',
    unknown: 'Unbekannt',
    group: 'Gruppe',
    titleInviteCode: 'Einladungscode',
    messageShareCodeWithFriends: 'Teile diesen Code mit Freunden: {{code}}',
    featureNotImplemented: 'Diese Funktion ist noch nicht verfügbar.',
    buttonJoinWithCode: 'Mit Code beitreten',
    sectionTitleYourFriendsGroups: 'Deine Freundesgruppen',
    emptyFriendsGroupsTitle: 'Noch keine Freundesgruppen',
    emptyFriendsGroupsSubtitle: 'Erstelle eine Freundesgruppe oder tritt einer bei, um gemeinsam Bibelquiz zu spielen!',
    inviteCopiedTitle: 'Kopiert!',
    inviteLinkCopied: 'Einladungslink in die Zwischenablage kopiert',
    inviteCodeCopied: 'Beitrittscode in die Zwischenablage kopiert',
    inviteCopyLinkError: 'Link konnte nicht kopiert werden',
    inviteCopyCodeError: 'Code konnte nicht kopiert werden',
    inviteShareError: 'Einladung konnte nicht geteilt werden',
    inviteShareRoomMessage: 'Komm in unseren Kingdom-Bible-Quiz-Raum für die nächste Herausforderung mit Familie und Freunden. Nutze den Code {{code}} oder öffne {{url}}',
    inviteShareEventMessage: 'Dieser Event-Link gehört zum separaten Quiz-Erlebnis für Gemeinden und Großgruppen: {{url}}',
    inviteShareTitle: '{{title}} beitreten',
    roomInviteEyebrow: 'Quiz für Familie & Freunde',
    roomInviteTitle: 'Du wurdest zu einem Quizraum eingeladen',
    roomInviteSubtitle: 'Tritt dem Raum in der App bei, um gemeinsam zu spielen, deinen Fortschritt zu synchronisieren und mit Familie und Freunden verbunden zu bleiben.',
    roomInviteCodeLabel: 'Raumcode',
    roomInviteSignedInHint: 'Du bist angemeldet und bereit, diesem Raum beizutreten.',
    roomInviteAuthHint: 'Erstelle ein kostenloses Konto oder melde dich an, um diesem Raum beizutreten und deinen Mehrspieler-Fortschritt zu behalten.',
    roomInviteContinue: 'Quizraum beitreten',
    roomInviteJoining: 'Raum wird betreten…',
    roomInviteSignIn: 'Anmelden oder Konto erstellen',
    roomInviteWebHint: 'Wenn die App bereits installiert ist, öffnet sich diese Einladung dort automatisch.',
    roomInviteInvalidTitle: 'Einladung nicht verfügbar',
    roomInviteInvalidBody: 'In diesem Einladungslink fehlen die Angaben, die zum Beitreten nötig sind.',
    roomInviteJoinError: 'Wir konnten dem Raum noch nicht beitreten. Bitte versuche es erneut mit dem Raumcode.',
    inviteHowToJoin: 'So trittst du bei:',
    inviteScanQr: 'Scanne diesen QR-Code mit deiner Kamera',
    inviteEnterCode: 'Oder gib den Beitrittscode ein: {{code}}',
    inviteTipsTitle: 'Tipps zum Teilen:',
    inviteTipFriendsFamily: 'Teile mit Familie oder Freunden, die du bereits kennst',
    inviteTipMessage: 'Sende den Link per SMS oder E-Mail',
    inviteTipCode: 'Nutze den Beitrittscode, falls sich der Link nicht direkt öffnet',
    groupSelectorLoadError: 'Deine Familien- und Freundesgruppen konnten nicht geladen werden. Bitte versuche es erneut.',
    groupSelectorEmptyTitle: 'Keine Gruppen gefunden',
    groupSelectorEmptyBody: 'Du bist noch in keiner Familien- oder Freundesgruppe.',
    groupSelectorSelect: 'Gruppe auswählen',
    groupSelectorTitle: 'Gruppe auswählen',
    groupTypeFamily: 'Familie',
    groupTypeFriends: 'Freunde',
    joinCodeRequired: 'Bitte gib einen Code oder Link ein.',
    joinFamilySuccess: 'Du bist der Familie beigetreten!',
    joinFriendsSuccess: 'Du bist der Freundesgruppe beigetreten!',
    joinByCodeTitle: '{{group}} mit Einladungscode beitreten',
    joinByCodeAction: '{{group}} beitreten',
    playAnotherQuizConfirm: 'Ja, neues Spiel starten',
    playAnotherQuizDecline: 'Nein, zurück zur Lobby',
    playAnotherQuizError: 'Neues Spiel konnte nicht gestartet werden. Bitte versuche es erneut.',
    playAnotherQuizFreshStart: 'Neues Spiel = Neustart für alle',
    playAnotherQuizResultsSaved: 'Die Ergebnisse des aktuellen Spiels werden gespeichert',
    playAnotherQuizReturnLobby: 'Alle Spieler kehren in die {{roomType}}-Lobby zurück',
    playAnotherQuizSettingUp: 'Wird eingerichtet…',
    playAnotherQuizSubtitle: 'Möchtest du mit derselben Gruppe ein neues Spiel starten?',
    playAnotherQuizTitle: 'Noch ein Quiz spielen?',
    // German translations
    tabFamily: 'Familie',
    tabFriends: 'Freunde',
    tabInvitations: 'Einladungen',
    actionAddFamilyMember: 'Familienmitglied hinzufügen',
    actionAddFriend: 'Freund hinzufügen',
    actionSendInvitation: 'Einladung senden',
    actionAccept: 'Akzeptieren',
    actionDecline: 'Ablehnen',
    actionRemove: 'Entfernen',
    actionSearch: 'Suchen',
    placeholderEmailUsername: 'E-Mail oder Benutzername eingeben',
    labelFamilyMemberName: 'Name des Familienmitglieds',
    labelFriendName: 'Name des Freundes',
    messageNoFamilyMembers: 'Keine Familienmitglieder gefunden.',
    messageNoFriends: 'Keine Freunde gefunden.',
    messageNoPendingInvitations: 'Keine ausstehenden Einladungen.',
    messageInvitationSent: 'Einladung an {{name}} gesendet.',
    messageInvitationAccepted: 'Einladung von {{name}} angenommen.',
    messageInvitationDeclined: 'Einladung von {{name}} abgelehnt.',
    messageRemovedSuccessfully: '{{name}} erfolgreich entfernt.',
    messageConfirmRemove: 'Sind Sie sicher, dass Sie {{name}} entfernen möchten?',
    titleCreateFamily: 'Familie erstellen',
    placeholderFamilyName: 'Familienname',
    buttonCreate: 'Erstellen',
    buttonCancel: 'Abbrechen',
    errorFamilyNameRequired: 'Familienname ist erforderlich.',
    errorFamilyLimit: 'Sie können bis zu 3 Familien angehören. Bitte verlassen Sie eine, bevor Sie eine neue Familie erstellen.',
    titleCreateFriendsGroup: 'Freundesgruppe erstellen',
    placeholderGroupName: 'Gruppenname',
    errorGroupNameRequired: 'Gruppenname ist erforderlich.',
    titleInviteMember: 'Mitglied einladen',
    labelShareInvite: 'Diese Einladung teilen:',
    buttonCopyLink: 'Link kopieren',
    buttonShareWhatsApp: 'Über WhatsApp teilen',
    labelInviteCode: 'Oder Einladungscode verwenden:',
    buttonCopyCode: 'Code kopieren',
    buttonDone: 'Fertig',
    labelPendingInvites: 'Ausstehende Einladungen:',
    titleJoinByCode: 'Familie über Einladungscode beitreten',
    placeholderInviteCode: 'Einladungscode eingeben...',
    buttonJoinFamily: 'Familie beitreten',
    buttonJoining: 'Beitritt...',
    titleFamilyMembers: 'Familienmitglieder',
    roleOwner: '⭐ Besitzer',
    roleAdmin: '⭐ Administrator',
    roleMember: 'Mitglied',
    buttonMakeAdmin: 'Zum Administrator machen',
    buttonClose: 'Schließen',
    titleFriendsMembers: 'Freundesgruppenmitglieder',
    tabFamilyHub: 'Familien-Hub',
    tabFriendsHub: 'Freunde-Hub',
    loadingFamilyHub: 'Familien-Hub wird geladen...',
    loadingFriendsHub: 'Freunde-Hub wird geladen...',
    errorLoadingFamily: 'Fehler beim Laden der Familiendaten',
    errorLoadingFriends: 'Fehler beim Laden der Freundesdaten',
    buttonRetry: 'Wiederholen',
    errorLoadingFamilyHub: 'Fehler beim Laden des Familien-Hubs',
    headerTitle: 'VERBINDEN UND GEMEINSAM WACHSEN',
    headerSubtitle: 'Bauen Sie Ihre spirituelle Gemeinschaft mit Familie und Freunden auf',
    loadingFamilyAndFriendsHub: 'Familien- und Freunde-Hub wird geladen',
    emptyStateNotInFamily: 'Sie sind noch nicht in einer Familie.',
    buttonCreateFamily: 'Familie erstellen',
    buttonJoinByInviteCode: 'Über Einladungscode beitreten',
    buttonViewInvitations: 'Einladungen anzeigen ({{count}})',
    sectionTitlePendingInvitations: 'Ausstehende Einladungen',
    buttonCreateFamilyOrFriendsGroup: 'Familie oder Freundesgruppe erstellen',
    alertSuccessInvitationAccepted: 'Einladung angenommen!',
    alertSuccessInvitationRejected: 'Einladung abgelehnt.',
    alertErrorInvitationResponse: 'Antwort auf Einladung fehlgeschlagen.',
    shareInviteMessage: 'Treten Sie meiner Familie oder Freundesgruppe bei Kingdom Bible Quiz bei! Tippen Sie auf diesen Link: {{url}}',
    alertErrorShareInvite: 'Einladungslink teilen fehlgeschlagen.',
    alertSuccessCodeCopied: 'Familiencode in die Zwischenablage kopiert.',
    alertSuccessFriendsCodeCopied: 'Freundegruppencode in die Zwischenablage kopiert.',
    alertErrorCopyCode: 'Code konnte nicht kopiert werden.',
    alertSuccessLeftFamily: 'Sie haben die Familie verlassen.',
    alertSuccessLeftFriendsGroup: 'Sie haben die Freundesgruppe verlassen.',
    alertErrorLeaveFamily: 'Familie verlassen fehlgeschlagen.',
    alertErrorLeaveFriendsGroup: 'Freundesgruppe verlassen fehlgeschlagen.',
    premiumCardFamilyLeaderboard: 'Familien-Bestenliste',
    premiumCardFamilyLeaderboardSubtitle: 'Verfolgen Sie das spirituelle Wachstum Ihrer Familie gemeinsam',
    premiumCardFriendsLeaderboard: 'Freunde-Bestenliste',
    premiumCardFriendsLeaderboardSubtitle: 'Konkurrieren und wachsen Sie mit Ihren Freunden',
    premiumCardComingSoon: 'Demnächst verfügbar',
    alertSuccessMemberPromoted: 'Mitglied zum Administrator befördert!',
    alertErrorPromoteMember: 'Mitglied befördern fehlgeschlagen.',
    liveScreenNoticeText: 'Suchen Sie nach Kirchen oder großen Teams? Schauen Sie sich die Live-Bildschirm-Registerkarte für Community-Events und große Gruppenfunktionen an.',
    liveScreenNoticeLink: 'Live-Bildschirm',
    
    // Family/Friends Group Cards
    membersLabel: 'Mitglieder',
    statusLabel: 'Status',
    activeStatus: 'Aktiv',
    shareLink: '🔗 Link teilen',
    copyCode: '📋 Code kopieren',
    viewMembers: '👥 Mitglieder anzeigen',
    leaveFamily: '🚆 Familie verlassen',
    leaveGroup: '🚆 Gruppe verlassen',
    enterFamilyLobby: 'Familien-Lobby betreten',
    enterFriendsLobby: 'Freunde-Lobby betreten',
    togetherSubtitle: 'Spielen, teilen und gemeinsam wachsen',
    familyBibleQuiz: 'Familien-Bibelquiz',
    familyQuizSubtitle: 'Lernt gemeinsam als Familie die Heilige Schrift',
    startQuiz: 'Quiz starten',
    inviteFamily: 'Familie einladen',
    signInToJoinFamily: 'Melden Sie sich an, um eine Familiengruppe zu erstellen oder beizutreten.',
    premiumGroupGateMessage: 'Treten Sie jeder Gruppe kostenlos mit einem Einladungscode bei. Erstellen und hosten Sie Ihre eigene mit Premium.',
    familyInviteMessage: 'Tritt meiner Familie "{{name}}" bei Kingdom Bible Quiz bei! Verwende den Code {{code}} oder tippe auf: {{url}}',
    invalidInviteCode: 'Dieser Einladungscode ist ungültig oder abgelaufen. Prüfe den Code und versuche es erneut.',
  },
  pt: {
    buttonOk: 'OK',
    buttonShare: 'Compartilhar',
    errorLoadingFriendsHub: 'Erro ao carregar o espaço de amigos',
    invitationFromTo: 'Convite de {{sender}} para entrar em {{group}}',
    unknown: 'Desconhecido',
    group: 'grupo',
    titleInviteCode: 'Código de convite',
    messageShareCodeWithFriends: 'Compartilhe este código com amigos: {{code}}',
    featureNotImplemented: 'Este recurso ainda não está disponível.',
    buttonJoinWithCode: 'Entrar com código',
    sectionTitleYourFriendsGroups: 'Seus grupos de amigos',
    emptyFriendsGroupsTitle: 'Ainda não há grupos de amigos',
    emptyFriendsGroupsSubtitle: 'Crie ou entre em um grupo de amigos para jogar quizzes bíblicos juntos!',
    inviteCopiedTitle: 'Copiado!',
    inviteLinkCopied: 'Link de convite copiado para a área de transferência',
    inviteCodeCopied: 'Código de entrada copiado para a área de transferência',
    inviteCopyLinkError: 'Falha ao copiar o link',
    inviteCopyCodeError: 'Falha ao copiar o código',
    inviteShareError: 'Falha ao compartilhar o convite',
    inviteShareRoomMessage: 'Entre na nossa sala do Kingdom Bible Quiz para o próximo desafio em família e com amigos. Use o código {{code}} ou abra {{url}}',
    inviteShareEventMessage: 'Este link de evento é para a experiência de quiz separada para igrejas e grandes grupos: {{url}}',
    inviteShareTitle: 'Entrar em {{title}}',
    roomInviteEyebrow: 'Quiz em família e com amigos',
    roomInviteTitle: 'Você foi convidado para uma sala de quiz',
    roomInviteSubtitle: 'Entre na sala pelo app para jogar juntos, manter seu progresso sincronizado e ficar conectado com sua família e amigos.',
    roomInviteCodeLabel: 'Código da sala',
    roomInviteSignedInHint: 'Você está conectado e pronto para entrar nesta sala.',
    roomInviteAuthHint: 'Crie uma conta gratuita ou entre para participar desta sala e manter seu progresso multijogador.',
    roomInviteContinue: 'Entrar na sala de quiz',
    roomInviteJoining: 'Entrando na sala…',
    roomInviteSignIn: 'Entrar ou criar conta',
    roomInviteWebHint: 'Se você já tem o app instalado, este convite abrirá nele automaticamente.',
    roomInviteInvalidTitle: 'Convite indisponível',
    roomInviteInvalidBody: 'Este link de convite não tem os dados necessários para entrar na sala.',
    roomInviteJoinError: 'Ainda não foi possível entrar nesta sala. Tente novamente com o código da sala.',
    inviteHowToJoin: 'Como entrar:',
    inviteScanQr: 'Escaneie este código QR com a câmera',
    inviteEnterCode: 'Ou digite o código: {{code}}',
    inviteTipsTitle: 'Dicas para compartilhar:',
    inviteTipFriendsFamily: 'Compartilhe com familiares ou amigos que você já conhece',
    inviteTipMessage: 'Envie o link por mensagem de texto ou e-mail',
    inviteTipCode: 'Use o código se o link não abrir diretamente',
    groupSelectorLoadError: 'Falha ao carregar seus grupos de família e amigos. Tente novamente.',
    groupSelectorEmptyTitle: 'Nenhum grupo encontrado',
    groupSelectorEmptyBody: 'Você ainda não está em nenhum grupo de família ou amigos.',
    groupSelectorSelect: 'Selecionar grupo',
    groupSelectorTitle: 'Selecionar grupo',
    groupTypeFamily: 'Família',
    groupTypeFriends: 'Amigos',
    joinCodeRequired: 'Digite um código ou link.',
    joinFamilySuccess: 'Você entrou na família!',
    joinFriendsSuccess: 'Você entrou no grupo de amigos!',
    joinByCodeTitle: 'Entrar em {{group}} com código de convite',
    joinByCodeAction: 'Entrar em {{group}}',
    playAnotherQuizConfirm: 'Sim, iniciar novo jogo',
    playAnotherQuizDecline: 'Não, voltar ao lobby',
    playAnotherQuizError: 'Não foi possível iniciar um novo jogo. Tente novamente.',
    playAnotherQuizFreshStart: 'Novo jogo = recomeço para todos',
    playAnotherQuizResultsSaved: 'Os resultados do jogo atual são salvos',
    playAnotherQuizReturnLobby: 'Todos os jogadores voltarão ao lobby de {{roomType}}',
    playAnotherQuizSettingUp: 'Preparando…',
    playAnotherQuizSubtitle: 'Quer iniciar um novo jogo com o mesmo grupo?',
    playAnotherQuizTitle: 'Jogar outro quiz?',
    // Portuguese translations
    tabFamily: 'Família',
    tabFriends: 'Amigos',
    tabInvitations: 'Convites',
    actionAddFamilyMember: 'Adicionar Membro da Família',
    actionAddFriend: 'Adicionar Amigo',
    actionSendInvitation: 'Enviar Convite',
    actionAccept: 'Aceitar',
    actionDecline: 'Recusar',
    actionRemove: 'Remover',
    actionSearch: 'Pesquisar',
    placeholderEmailUsername: 'Digite o email ou nome de usuário',
    labelFamilyMemberName: 'Nome do Membro da Família',
    labelFriendName: 'Nome do Amigo',
    messageNoFamilyMembers: 'Nenhum membro da família encontrado.',
    messageNoFriends: 'Nenhum amigo encontrado.',
    messageNoPendingInvitations: 'Nenhum convite pendente.',
    messageInvitationSent: 'Convite enviado para {{name}}.',
    messageInvitationAccepted: 'Convite aceito de {{name}}.',
    messageInvitationDeclined: 'Convite recusado de {{name}}.',
    messageRemovedSuccessfully: '{{name}} removido com sucesso.',
    messageConfirmRemove: 'Tem certeza de que deseja remover {{name}}?',
    titleCreateFamily: 'Criar Família',
    placeholderFamilyName: 'Nome da Família',
    buttonCreate: 'Criar',
    buttonCancel: 'Cancelar',
    errorFamilyNameRequired: 'Nome da família é obrigatório.',
    errorFamilyLimit: 'Você pode pertencer a até 3 famílias. Por favor, saia de uma antes de criar uma nova família.',
    titleCreateFriendsGroup: 'Criar Grupo de Amigos',
    placeholderGroupName: 'Nome do Grupo',
    errorGroupNameRequired: 'Nome do grupo é obrigatório.',
    titleInviteMember: 'Convidar Membro',
    labelShareInvite: 'Compartilhar este convite:',
    buttonCopyLink: 'Copiar Link',
    buttonShareWhatsApp: 'Compartilhar via WhatsApp',
    labelInviteCode: 'Ou use o código do convite:',
    buttonCopyCode: 'Copiar Código',
    buttonDone: 'Concluído',
    labelPendingInvites: 'Convites Pendentes:',
    titleJoinByCode: 'Entrar na Família por Código de Convite',
    placeholderInviteCode: 'Digite o código do convite...',
    buttonJoinFamily: 'Entrar na Família',
    buttonJoining: 'Entrando...',
    titleFamilyMembers: 'Membros da Família',
    roleOwner: '⭐ Proprietário',
    roleAdmin: '⭐ Administrador',
    roleMember: 'Membro',
    buttonMakeAdmin: 'Tornar Administrador',
    buttonClose: 'Fechar',
    titleFriendsMembers: 'Membros do Grupo de Amigos',
    tabFamilyHub: 'Central da Família',
    tabFriendsHub: 'Central dos Amigos',
    loadingFamilyHub: 'Carregando Central da Família...',
    loadingFriendsHub: 'Carregando Central dos Amigos...',
    errorLoadingFamily: 'Erro ao carregar dados da família',
    errorLoadingFriends: 'Erro ao carregar dados dos amigos',
    buttonRetry: 'Tentar Novamente',
    errorLoadingFamilyHub: 'Erro ao carregar central da família',
    headerTitle: 'CONECTE-SE E CRESÇA JUNTOS',
    headerSubtitle: 'Construa sua comunidade espiritual com família e amigos',
    loadingFamilyAndFriendsHub: 'Carregando Central da Família e Amigos',
    emptyStateNotInFamily: 'Você ainda não está em uma família.',
    buttonCreateFamily: 'Criar Família',
    buttonJoinByInviteCode: 'Entrar por Código de Convite',
    buttonViewInvitations: 'Ver Convites ({{count}})',
    sectionTitlePendingInvitations: 'Convites Pendentes',
    buttonCreateFamilyOrFriendsGroup: 'Criar Família ou Grupo de Amigos',
    alertSuccessInvitationAccepted: 'Convite aceito!',
    alertSuccessInvitationRejected: 'Convite recusado.',
    alertErrorInvitationResponse: 'Falha ao responder ao convite.',
    shareInviteMessage: 'Junte-se à minha família ou grupo de amigos no Kingdom Bible Quiz! Toque neste link: {{url}}',
    alertErrorShareInvite: 'Falha ao compartilhar link do convite.',
    alertSuccessCodeCopied: 'Código da família copiado para a área de transferência.',
    alertSuccessFriendsCodeCopied: 'Código do grupo de amigos copiado para a área de transferência.',
    alertErrorCopyCode: 'Não foi possível copiar o código.',
    alertSuccessLeftFamily: 'Você saiu da família.',
    alertSuccessLeftFriendsGroup: 'Você saiu do grupo de amigos.',
    alertErrorLeaveFamily: 'Falha ao sair da família.',
    alertErrorLeaveFriendsGroup: 'Falha ao sair do grupo de amigos.',
    premiumCardFamilyLeaderboard: 'Ranking da Família',
    premiumCardFamilyLeaderboardSubtitle: 'Acompanhe o crescimento espiritual da sua família juntos',
    premiumCardFriendsLeaderboard: 'Ranking dos Amigos',
    premiumCardFriendsLeaderboardSubtitle: 'Compete e cresça junto com seus amigos',
    premiumCardComingSoon: 'Em Breve',
    alertSuccessMemberPromoted: 'Membro promovido a administrador!',
    alertErrorPromoteMember: 'Falha ao promover membro.',
    liveScreenNoticeText: 'Procurando por igrejas ou equipes grandes? Confira a aba Tela ao Vivo para eventos comunitários e recursos de grupos grandes.',
    liveScreenNoticeLink: 'Tela ao Vivo',
    
    // Family/Friends Group Cards
    membersLabel: 'Membros',
    statusLabel: 'Status',
    activeStatus: 'Ativo',
    shareLink: '🔗 Compartilhar Link',
    copyCode: '📋 Copiar Código',
    viewMembers: '👥 Ver Membros',
    leaveFamily: '🚆 Sair da Família',
    leaveGroup: '🚆 Sair do Grupo',
    enterFamilyLobby: 'Entrar no Lobby da Família',
    enterFriendsLobby: 'Entrar no Lobby dos Amigos',
    togetherSubtitle: 'Jogue, compartilhe e cresça com os outros',
    familyBibleQuiz: 'Quiz Bíblico em Família',
    familyQuizSubtitle: 'Aprenda as Escrituras juntos em família',
    startQuiz: 'Iniciar Quiz',
    inviteFamily: 'Convidar Família',
    signInToJoinFamily: 'Faça login para criar ou entrar em um grupo familiar.',
    premiumGroupGateMessage: 'Entre em qualquer grupo gratuitamente com um código de convite. Crie e hospede o seu com Premium.',
    familyInviteMessage: 'Junte-se à minha família "{{name}}" no Kingdom Bible Quiz! Use o código {{code}} ou toque em: {{url}}',
    invalidInviteCode: 'Este código de convite é inválido ou expirou. Verifique o código e tente novamente.',
  },
  ru: {
    buttonOk: 'ОК',
    buttonShare: 'Поделиться',
    errorLoadingFriendsHub: 'Ошибка загрузки раздела друзей',
    invitationFromTo: 'Приглашение от {{sender}} присоединиться: {{group}}',
    unknown: 'Неизвестно',
    group: 'группа',
    titleInviteCode: 'Код приглашения',
    messageShareCodeWithFriends: 'Поделитесь этим кодом с друзьями: {{code}}',
    featureNotImplemented: 'Эта функция пока недоступна.',
    buttonJoinWithCode: 'Войти по коду',
    sectionTitleYourFriendsGroups: 'Ваши группы друзей',
    emptyFriendsGroupsTitle: 'Групп друзей пока нет',
    emptyFriendsGroupsSubtitle: 'Создайте группу друзей или присоединитесь к ней, чтобы вместе играть в библейские викторины!',
    inviteCopiedTitle: 'Скопировано!',
    inviteLinkCopied: 'Ссылка-приглашение скопирована в буфер обмена',
    inviteCodeCopied: 'Код для входа скопирован в буфер обмена',
    inviteCopyLinkError: 'Не удалось скопировать ссылку',
    inviteCopyCodeError: 'Не удалось скопировать код',
    inviteShareError: 'Не удалось поделиться приглашением',
    inviteShareRoomMessage: 'Присоединяйтесь к нашей комнате Kingdom Bible Quiz для следующего испытания с семьёй и друзьями. Код: {{code}} или откройте {{url}}',
    inviteShareEventMessage: 'Эта ссылка на событие относится к отдельной викторине для церквей и больших групп: {{url}}',
    inviteShareTitle: 'Присоединиться к «{{title}}»',
    roomInviteEyebrow: 'Викторина для семьи и друзей',
    roomInviteTitle: 'Вас пригласили в комнату викторины',
    roomInviteSubtitle: 'Присоединяйтесь к комнате в приложении, чтобы играть вместе, синхронизировать прогресс и оставаться на связи с семьёй и друзьями.',
    roomInviteCodeLabel: 'Код комнаты',
    roomInviteSignedInHint: 'Вы вошли в аккаунт и готовы присоединиться к этой комнате.',
    roomInviteAuthHint: 'Создайте бесплатный аккаунт или войдите, чтобы присоединиться к комнате и сохранить прогресс в многопользовательской игре.',
    roomInviteContinue: 'Войти в комнату викторины',
    roomInviteJoining: 'Подключение к комнате…',
    roomInviteSignIn: 'Войти или создать аккаунт',
    roomInviteWebHint: 'Если приложение уже установлено, это приглашение откроется в нём автоматически.',
    roomInviteInvalidTitle: 'Приглашение недоступно',
    roomInviteInvalidBody: 'В этой ссылке-приглашении не хватает данных для входа в комнату.',
    roomInviteJoinError: 'Пока не удалось войти в эту комнату. Попробуйте ввести код комнаты ещё раз.',
    inviteHowToJoin: 'Как присоединиться:',
    inviteScanQr: 'Отсканируйте этот QR-код камерой',
    inviteEnterCode: 'Или введите код: {{code}}',
    inviteTipsTitle: 'Советы по приглашению:',
    inviteTipFriendsFamily: 'Делитесь с родными и друзьями, которых вы уже знаете',
    inviteTipMessage: 'Отправьте ссылку в сообщении или по электронной почте',
    inviteTipCode: 'Используйте код, если ссылка не открывается напрямую',
    groupSelectorLoadError: 'Не удалось загрузить ваши группы семьи и друзей. Попробуйте ещё раз.',
    groupSelectorEmptyTitle: 'Группы не найдены',
    groupSelectorEmptyBody: 'Вы пока не состоите ни в одной группе семьи или друзей.',
    groupSelectorSelect: 'Выбрать группу',
    groupSelectorTitle: 'Выбор группы',
    groupTypeFamily: 'Семья',
    groupTypeFriends: 'Друзья',
    joinCodeRequired: 'Введите код или ссылку.',
    joinFamilySuccess: 'Вы присоединились к семье!',
    joinFriendsSuccess: 'Вы присоединились к группе друзей!',
    joinByCodeTitle: 'Присоединиться к «{{group}}» по коду приглашения',
    joinByCodeAction: 'Присоединиться: {{group}}',
    playAnotherQuizConfirm: 'Да, начать новую игру',
    playAnotherQuizDecline: 'Нет, вернуться в лобби',
    playAnotherQuizError: 'Не удалось начать новую игру. Попробуйте ещё раз.',
    playAnotherQuizFreshStart: 'Новая игра — новый старт для всех',
    playAnotherQuizResultsSaved: 'Результаты текущей игры сохранены',
    playAnotherQuizReturnLobby: 'Все игроки вернутся в лобби ({{roomType}})',
    playAnotherQuizSettingUp: 'Подготовка…',
    playAnotherQuizSubtitle: 'Начать новую игру с той же группой?',
    playAnotherQuizTitle: 'Сыграть ещё одну викторину?',
    // Russian translations
    tabFamily: 'Семья',
    tabFriends: 'Друзья',
    tabInvitations: 'Приглашения',
    actionAddFamilyMember: 'Добавить Члена Семьи',
    actionAddFriend: 'Добавить Друга',
    actionSendInvitation: 'Отправить Приглашение',
    actionAccept: 'Принять',
    actionDecline: 'Отклонить',
    actionRemove: 'Удалить',
    actionSearch: 'Поиск',
    placeholderEmailUsername: 'Введите email или имя пользователя',
    labelFamilyMemberName: 'Имя Члена Семьи',
    labelFriendName: 'Имя Друга',
    messageNoFamilyMembers: 'Членов семьи не найдено.',
    messageNoFriends: 'Друзей не найдено.',
    messageNoPendingInvitations: 'Нет ожидающих приглашений.',
    messageInvitationSent: 'Приглашение отправлено {{name}}.',
    messageInvitationAccepted: 'Приглашение принято от {{name}}.',
    messageInvitationDeclined: 'Приглашение отклонено от {{name}}.',
    messageRemovedSuccessfully: '{{name}} успешно удален.',
    messageConfirmRemove: 'Вы уверены, что хотите удалить {{name}}?',
    titleCreateFamily: 'Создать Семью',
    placeholderFamilyName: 'Название Семьи',
    buttonCreate: 'Создать',
    buttonCancel: 'Отмена',
    errorFamilyNameRequired: 'Название семьи обязательно.',
    errorFamilyLimit: 'Вы можете принадлежать к максимум 3 семьям. Пожалуйста, покиньте одну перед созданием новой семьи.',
    titleCreateFriendsGroup: 'Создать Группу Друзей',
    placeholderGroupName: 'Название Группы',
    errorGroupNameRequired: 'Название группы обязательно.',
    titleInviteMember: 'Пригласить Члена',
    labelShareInvite: 'Поделиться этим приглашением:',
    buttonCopyLink: 'Копировать Ссылку',
    buttonShareWhatsApp: 'Поделиться через WhatsApp',
    labelInviteCode: 'Или используйте код приглашения:',
    buttonCopyCode: 'Копировать Код',
    buttonDone: 'Готово',
    labelPendingInvites: 'Ожидающие Приглашения:',
    titleJoinByCode: 'Присоединиться к Семье по Коду Приглашения',
    placeholderInviteCode: 'Введите код приглашения...',
    buttonJoinFamily: 'Присоединиться к Семье',
    buttonJoining: 'Присоединение...',
    titleFamilyMembers: 'Члены Семьи',
    roleOwner: '⭐ Владелец',
    roleAdmin: '⭐ Администратор',
    roleMember: 'Член',
    buttonMakeAdmin: 'Сделать Администратором',
    buttonClose: 'Закрыть',
    titleFriendsMembers: 'Члены Группы Друзей',
    tabFamilyHub: 'Центр Семьи',
    tabFriendsHub: 'Центр Друзей',
    loadingFamilyHub: 'Загрузка Центра Семьи...',
    loadingFriendsHub: 'Загрузка Центра Друзей...',
    errorLoadingFamily: 'Ошибка загрузки данных семьи',
    errorLoadingFriends: 'Ошибка загрузки данных друзей',
    buttonRetry: 'Повторить',
    errorLoadingFamilyHub: 'Ошибка загрузки центра семьи',
    headerTitle: 'СОЕДИНЯЙТЕСЬ И РАСТИТЕ ВМЕСТЕ',
    headerSubtitle: 'Постройте свое духовное сообщество с семьей и друзьями',
    loadingFamilyAndFriendsHub: 'Загрузка Центра Семьи и Друзей',
    emptyStateNotInFamily: 'Вы еще не в семье.',
    buttonCreateFamily: 'Создать Семью',
    buttonJoinByInviteCode: 'Присоединиться по Коду Приглашения',
    buttonViewInvitations: 'Просмотр Приглашений ({{count}})',
    sectionTitlePendingInvitations: 'Ожидающие Приглашения',
    buttonCreateFamilyOrFriendsGroup: 'Создать Семью или Группу Друзей',
    alertSuccessInvitationAccepted: 'Приглашение принято!',
    alertSuccessInvitationRejected: 'Приглашение отклонено.',
    alertErrorInvitationResponse: 'Не удалось ответить на приглашение.',
    shareInviteMessage: 'Присоединяйтесь к моей семье или группе друзей в Kingdom Bible Quiz! Нажмите на эту ссылку: {{url}}',
    alertErrorShareInvite: 'Не удалось поделиться ссылкой приглашения.',
    alertSuccessCodeCopied: 'Код семьи скопирован в буфер обмена.',
    alertSuccessFriendsCodeCopied: 'Код группы друзей скопирован в буфер обмена.',
    alertErrorCopyCode: 'Не удалось скопировать код.',
    alertSuccessLeftFamily: 'Вы покинули семью.',
    alertSuccessLeftFriendsGroup: 'Вы покинули группу друзей.',
    alertErrorLeaveFamily: 'Не удалось покинуть семью.',
    alertErrorLeaveFriendsGroup: 'Не удалось покинуть группу друзей.',
    premiumCardFamilyLeaderboard: 'Рейтинг Семьи',
    premiumCardFamilyLeaderboardSubtitle: 'Отслеживайте духовный рост вашей семьи вместе',
    premiumCardFriendsLeaderboard: 'Рейтинг Друзей',
    premiumCardFriendsLeaderboardSubtitle: 'Соревнуйтесь и растите вместе с друзьями',
    premiumCardComingSoon: 'Скоро',
    alertSuccessMemberPromoted: 'Член повышен до администратора!',
    alertErrorPromoteMember: 'Не удалось повысить члена.',
    liveScreenNoticeText: 'Ищете церкви или большие команды? Ознакомьтесь с вкладкой Живой Экран для общественных мероприятий и функций больших групп.',
    liveScreenNoticeLink: 'Живой Экран',
    
    // Family/Friends Group Cards
    membersLabel: 'Члены',
    statusLabel: 'Статус',
    activeStatus: 'Активный',
    shareLink: '🔗 Поделиться Ссылкой',
    copyCode: '📋 Копировать Код',
    viewMembers: '👥 Посмотреть Членов',
    leaveFamily: '🚆 Покинуть Семью',
    leaveGroup: '🚆 Покинуть Группу',
    enterFamilyLobby: 'Войти в Лобби Семьи',
    enterFriendsLobby: 'Войти в Лобби Друзей',
    togetherSubtitle: 'Играйте, делитесь и растите вместе с другими',
    familyBibleQuiz: 'Семейная Библейская Викторина',
    familyQuizSubtitle: 'Изучайте Писание вместе всей семьёй',
    startQuiz: 'Начать Викторину',
    inviteFamily: 'Пригласить Семью',
    signInToJoinFamily: 'Войдите, чтобы создать или присоединиться к семейной группе.',
    premiumGroupGateMessage: 'Присоединяйтесь к любой группе бесплатно по коду приглашения. Создавайте и размещайте свою с Premium.',
    familyInviteMessage: 'Присоединяйся к моей семье "{{name}}" в Kingdom Bible Quiz! Используй код {{code}} или нажми: {{url}}',
    invalidInviteCode: 'Этот код приглашения недействителен или истёк. Проверьте код и повторите попытку.',
  },
  tl: {
    buttonOk: 'OK',
    buttonShare: 'Ibahagi',
    errorLoadingFriendsHub: 'Error sa pag-load ng friends hub',
    invitationFromTo: 'Imbitasyon mula kay {{sender}} para sumali sa {{group}}',
    unknown: 'Hindi alam',
    group: 'grupo',
    titleInviteCode: 'Code ng Imbitasyon',
    messageShareCodeWithFriends: 'Ibahagi ang code na ito sa mga kaibigan: {{code}}',
    featureNotImplemented: 'Hindi pa available ang feature na ito.',
    buttonJoinWithCode: 'Sumali gamit ang Code',
    sectionTitleYourFriendsGroups: 'Ang Iyong mga Grupo ng Kaibigan',
    emptyFriendsGroupsTitle: 'Wala Pang Grupo ng Kaibigan',
    emptyFriendsGroupsSubtitle: 'Gumawa o sumali sa grupo ng mga kaibigan para sabay na maglaro ng Bible quiz!',
    inviteCopiedTitle: 'Nakopya!',
    inviteLinkCopied: 'Nakopya sa clipboard ang link ng imbitasyon',
    inviteCodeCopied: 'Nakopya sa clipboard ang code sa pagsali',
    inviteCopyLinkError: 'Hindi nakopya ang link',
    inviteCopyCodeError: 'Hindi nakopya ang code',
    inviteShareError: 'Hindi naibahagi ang imbitasyon',
    inviteShareRoomMessage: 'Sumali sa aming Kingdom Bible Quiz room para sa susunod na hamon ng pamilya at mga kaibigan. Gamitin ang code na {{code}} o buksan ang {{url}}',
    inviteShareEventMessage: 'Ang event link na ito ay para sa hiwalay na quiz experience ng simbahan at malalaking grupo: {{url}}',
    inviteShareTitle: 'Sumali sa {{title}}',
    roomInviteEyebrow: 'Quiz ng Pamilya at mga Kaibigan',
    roomInviteTitle: 'Inimbitahan ka sa isang quiz room',
    roomInviteSubtitle: 'Sumali sa kuwarto sa app para sabay na maglaro, panatilihing naka-sync ang iyong progreso, at manatiling konektado sa pamilya at mga kaibigan.',
    roomInviteCodeLabel: 'Code ng Kuwarto',
    roomInviteSignedInHint: 'Naka-sign in ka at handa nang sumali sa kuwartong ito.',
    roomInviteAuthHint: 'Gumawa ng libreng account o mag-sign in para sumali sa kuwartong ito at mapanatili ang iyong multiplayer progress.',
    roomInviteContinue: 'Sumali sa Quiz Room',
    roomInviteJoining: 'Sumasali sa kuwarto…',
    roomInviteSignIn: 'Mag-sign in o gumawa ng account',
    roomInviteWebHint: 'Kung naka-install na ang app, awtomatikong magbubukas doon ang imbitasyong ito.',
    roomInviteInvalidTitle: 'Hindi available ang imbitasyon',
    roomInviteInvalidBody: 'Kulang ang detalye ng link ng imbitasyong ito para makasali sa kuwarto.',
    roomInviteJoinError: 'Hindi pa kami nakasali sa kuwartong ito. Pakisubukang muli gamit ang room code.',
    inviteHowToJoin: 'Paano Sumali:',
    inviteScanQr: 'I-scan ang QR code na ito gamit ang iyong camera',
    inviteEnterCode: 'O ilagay ang join code: {{code}}',
    inviteTipsTitle: 'Mga Tip sa Pagbabahagi:',
    inviteTipFriendsFamily: 'Ibahagi sa pamilya o mga kaibigang kilala mo na',
    inviteTipMessage: 'Ipadala ang link sa text message o email',
    inviteTipCode: 'Gamitin ang join code kung hindi direktang bumukas ang link',
    groupSelectorLoadError: 'Hindi ma-load ang iyong mga grupo ng pamilya at kaibigan. Pakisubukang muli.',
    groupSelectorEmptyTitle: 'Walang Nahanap na Grupo',
    groupSelectorEmptyBody: 'Wala ka pa sa anumang grupo ng pamilya o kaibigan.',
    groupSelectorSelect: 'Pumili ng Grupo',
    groupSelectorTitle: 'Pumili ng Grupo',
    groupTypeFamily: 'Pamilya',
    groupTypeFriends: 'Mga Kaibigan',
    joinCodeRequired: 'Maglagay ng code o link.',
    joinFamilySuccess: 'Sumali ka na sa pamilya!',
    joinFriendsSuccess: 'Sumali ka na sa grupo ng mga kaibigan!',
    joinByCodeTitle: 'Sumali sa {{group}} gamit ang Invite Code',
    joinByCodeAction: 'Sumali sa {{group}}',
    playAnotherQuizConfirm: 'Oo, Magsimula ng Bagong Laro',
    playAnotherQuizDecline: 'Hindi, Bumalik sa Lobby',
    playAnotherQuizError: 'Hindi nasimulan ang bagong laro. Pakisubukang muli.',
    playAnotherQuizFreshStart: 'Bagong laro = bagong simula para sa lahat',
    playAnotherQuizResultsSaved: 'Nase-save ang mga resulta ng kasalukuyang laro',
    playAnotherQuizReturnLobby: 'Babalik ang lahat ng manlalaro sa lobby ng {{roomType}}',
    playAnotherQuizSettingUp: 'Inihahanda…',
    playAnotherQuizSubtitle: 'Gusto mo bang magsimula ng bagong laro kasama ang parehong grupo?',
    playAnotherQuizTitle: 'Maglaro Pa ng Isang Quiz?',
    // Tagalog translations
    tabFamily: 'Pamilya',
    tabFriends: 'Mga Kaibigan',
    tabInvitations: 'Mga Imbitasyon',
    actionAddFamilyMember: 'Magdagdag ng Miyembro ng Pamilya',
    actionAddFriend: 'Magdagdag ng Kaibigan',
    actionSendInvitation: 'Magpadala ng Imbitasyon',
    actionAccept: 'Tanggapin',
    actionDecline: 'Tanggihan',
    actionRemove: 'Alisin',
    actionSearch: 'Maghanap',
    placeholderEmailUsername: 'Ilagay ang email o username',
    labelFamilyMemberName: 'Pangalan ng Miyembro ng Pamilya',
    labelFriendName: 'Pangalan ng Kaibigan',
    messageNoFamilyMembers: 'Walang nahanap na miyembro ng pamilya.',
    messageNoFriends: 'Walang nahanap na kaibigan.',
    messageNoPendingInvitations: 'Walang naghihintay na imbitasyon.',
    messageInvitationSent: 'Imbitasyon na ipinadala kay {{name}}.',
    messageInvitationAccepted: 'Imbitasyon na tinanggap mula kay {{name}}.',
    messageInvitationDeclined: 'Imbitasyon na tinanggihan mula kay {{name}}.',
    messageRemovedSuccessfully: 'Matagumpay na inalis si {{name}}.',
    messageConfirmRemove: 'Sigurado ka bang gusto mong alisin si {{name}}?',
    titleCreateFamily: 'Lumikha ng Pamilya',
    placeholderFamilyName: 'Pangalan ng Pamilya',
    buttonCreate: 'Lumikha',
    buttonCancel: 'Kanselahin',
    errorFamilyNameRequired: 'Kinakailangan ang pangalan ng pamilya.',
    errorFamilyLimit: 'Maaari kang maging miyembro ng hanggang 3 pamilya. Mangyaring umalis sa isa bago lumikha ng bagong pamilya.',
    titleCreateFriendsGroup: 'Lumikha ng Grupo ng mga Kaibigan',
    placeholderGroupName: 'Pangalan ng Grupo',
    errorGroupNameRequired: 'Kinakailangan ang pangalan ng grupo.',
    titleInviteMember: 'Mag-imbitang Miyembro',
    labelShareInvite: 'Ibahagi ang imbitasyong ito:',
    buttonCopyLink: 'Kopyahin ang Link',
    buttonShareWhatsApp: 'Ibahagi sa pamamagitan ng WhatsApp',
    labelInviteCode: 'O gamitin ang invite code:',
    buttonCopyCode: 'Kopyahin ang Code',
    buttonDone: 'Tapos',
    labelPendingInvites: 'Mga Naghihintay na Imbitasyon:',
    titleJoinByCode: 'Sumama sa Pamilya gamit ang Invite Code',
    placeholderInviteCode: 'Ilagay ang invite code...',
    buttonJoinFamily: 'Sumama sa Pamilya',
    buttonJoining: 'Sumasama...',
    titleFamilyMembers: 'Mga Miyembro ng Pamilya',
    roleOwner: '⭐ May-ari',
    roleAdmin: '⭐ Admin',
    roleMember: 'Miyembro',
    buttonMakeAdmin: 'Gawing Admin',
    buttonClose: 'Isara',
    titleFriendsMembers: 'Mga Miyembro ng Grupo ng mga Kaibigan',
    tabFamilyHub: 'Family Hub',
    tabFriendsHub: 'Friends Hub',
    loadingFamilyHub: 'Naglo-load ng Family Hub...',
    loadingFriendsHub: 'Naglo-load ng Friends Hub...',
    errorLoadingFamily: 'Error sa pag-load ng family data',
    errorLoadingFriends: 'Error sa pag-load ng friends data',
    buttonRetry: 'Subukan Muli',
    errorLoadingFamilyHub: 'Error sa pag-load ng family hub',
    headerTitle: 'KUMUKONEKTA AT LUMAGO NANG SAMA-SAMA',
    headerSubtitle: 'Bumuo ng inyong spiritual na komunidad kasama ang pamilya at mga kaibigan',
    loadingFamilyAndFriendsHub: 'Naglo-load ng Family at Friends Hub',
    emptyStateNotInFamily: 'Hindi ka pa nakasali sa pamilya.',
    buttonCreateFamily: 'Lumikha ng Pamilya',
    buttonJoinByInviteCode: 'Sumama gamit ang Invite Code',
    buttonViewInvitations: 'Tingnan ang mga Imbitasyon ({{count}})',
    sectionTitlePendingInvitations: 'Mga Naghihintay na Imbitasyon',
    buttonCreateFamilyOrFriendsGroup: 'Lumikha ng Pamilya o Grupo ng mga Kaibigan',
    alertSuccessInvitationAccepted: 'Imbitasyon na tinanggap!',
    alertSuccessInvitationRejected: 'Imbitasyon na tinanggihan.',
    alertErrorInvitationResponse: 'Hindi nakatugon sa imbitasyon.',
    shareInviteMessage: 'Sumama sa aking pamilya o grupo ng mga kaibigan sa Kingdom Bible Quiz! I-tap ang link na ito: {{url}}',
    alertErrorShareInvite: 'Hindi na-share ang invite link.',
    alertSuccessCodeCopied: 'Na-copy ang family code sa clipboard.',
    alertSuccessFriendsCodeCopied: 'Na-copy ang friends group code sa clipboard.',
    alertErrorCopyCode: 'Hindi ma-copy ang code.',
    alertSuccessLeftFamily: 'Umalis ka sa pamilya.',
    alertSuccessLeftFriendsGroup: 'Umalis ka sa grupo ng mga kaibigan.',
    alertErrorLeaveFamily: 'Hindi makaalis sa pamilya.',
    alertErrorLeaveFriendsGroup: 'Hindi makaalis sa grupo ng mga kaibigan.',
    premiumCardFamilyLeaderboard: 'Family Leaderboard',
    premiumCardFamilyLeaderboardSubtitle: 'Subaybayan ang spiritual growth ng inyong pamilya',
    premiumCardFriendsLeaderboard: 'Friends Leaderboard',
    premiumCardFriendsLeaderboardSubtitle: 'Makipagkumpitensya at lumago kasama ang mga kaibigan',
    premiumCardComingSoon: 'Paparating Na',
    alertSuccessMemberPromoted: 'Miyembro na na-promote bilang admin!',
    alertErrorPromoteMember: 'Hindi ma-promote ang miyembro.',
    liveScreenNoticeText: 'Naghahanap ng mga simbahan o malalaking teams? Tingnan ang Live Screen tab para sa community events at large group features.',
    liveScreenNoticeLink: 'Live Screen',
    
    // Family/Friends Group Cards
    membersLabel: 'Mga Miyembro',
    statusLabel: 'Status',
    activeStatus: 'Aktibo',
    shareLink: '🔗 Ibahagi ang Link',
    copyCode: '📋 Kopyahin ang Code',
    viewMembers: '👥 Tingnan ang Mga Miyembro',
    leaveFamily: '🚆 Umalis sa Pamilya',
    leaveGroup: '🚆 Umalis sa Grupo',
    enterFamilyLobby: 'Pumasok sa Family Lobby',
    enterFriendsLobby: 'Pumasok sa Friends Lobby',
    togetherSubtitle: 'Maglaro, magbahagi, at lumago kasama ang iba',
    familyBibleQuiz: 'Family Bible Quiz',
    familyQuizSubtitle: 'Pag-aralan ang Banal na Kasulatan bilang pamilya',
    startQuiz: 'Simulan ang Quiz',
    inviteFamily: 'Imbitahan ang Pamilya',
    signInToJoinFamily: 'Mag-sign in upang lumikha o sumali sa isang family group.',
    premiumGroupGateMessage: 'Sumali sa anumang grupo nang libre gamit ang invite code. Gumawa at mag-host ng sarili mo gamit ang Premium.',
    familyInviteMessage: 'Sumali sa aking pamilya "{{name}}" sa Kingdom Bible Quiz! Gamitin ang code {{code}} o pindutin: {{url}}',
    invalidInviteCode: 'Hindi wasto o nag-expire na ang invite code na ito. Suriin ang code at subukang muli.',
  },
  it: {
    buttonOk: 'OK',
    buttonShare: 'Condividi',
    errorLoadingFriendsHub: 'Errore nel caricamento dell\'area amici',
    invitationFromTo: 'Invito di {{sender}} a unirti a {{group}}',
    unknown: 'Sconosciuto',
    group: 'gruppo',
    titleInviteCode: 'Codice invito',
    messageShareCodeWithFriends: 'Condividi questo codice con gli amici: {{code}}',
    featureNotImplemented: 'Questa funzione non è ancora disponibile.',
    buttonJoinWithCode: 'Unisciti con codice',
    sectionTitleYourFriendsGroups: 'I tuoi gruppi di amici',
    emptyFriendsGroupsTitle: 'Ancora nessun gruppo di amici',
    emptyFriendsGroupsSubtitle: 'Crea o unisciti a un gruppo di amici per giocare insieme ai quiz biblici!',
    inviteCopiedTitle: 'Copiato!',
    inviteLinkCopied: 'Link di invito copiato negli appunti',
    inviteCodeCopied: 'Codice di accesso copiato negli appunti',
    inviteCopyLinkError: 'Impossibile copiare il link',
    inviteCopyCodeError: 'Impossibile copiare il codice',
    inviteShareError: 'Impossibile condividere l\'invito',
    inviteShareRoomMessage: 'Unisciti alla nostra stanza di Kingdom Bible Quiz per la prossima sfida con famiglia e amici. Usa il codice {{code}} o apri {{url}}',
    inviteShareEventMessage: 'Questo link evento è per l\'esperienza quiz separata per chiese e grandi gruppi: {{url}}',
    inviteShareTitle: 'Unisciti a {{title}}',
    roomInviteEyebrow: 'Quiz con famiglia e amici',
    roomInviteTitle: 'Sei stato invitato a una stanza quiz',
    roomInviteSubtitle: 'Unisciti alla stanza nell\'app per giocare insieme, mantenere sincronizzati i tuoi progressi e restare in contatto con famiglia e amici.',
    roomInviteCodeLabel: 'Codice stanza',
    roomInviteSignedInHint: 'Hai effettuato l\'accesso e sei pronto a unirti a questa stanza.',
    roomInviteAuthHint: 'Crea un account gratuito o accedi per unirti a questa stanza e conservare i tuoi progressi multigiocatore.',
    roomInviteContinue: 'Unisciti alla stanza quiz',
    roomInviteJoining: 'Accesso alla stanza…',
    roomInviteSignIn: 'Accedi o crea un account',
    roomInviteWebHint: 'Se hai già installato l\'app, questo invito si aprirà automaticamente al suo interno.',
    roomInviteInvalidTitle: 'Invito non disponibile',
    roomInviteInvalidBody: 'Questo link di invito non contiene i dettagli necessari per unirsi.',
    roomInviteJoinError: 'Non è stato ancora possibile unirsi a questa stanza. Riprova con il codice della stanza.',
    inviteHowToJoin: 'Come unirsi:',
    inviteScanQr: 'Inquadra questo codice QR con la fotocamera',
    inviteEnterCode: 'Oppure inserisci il codice: {{code}}',
    inviteTipsTitle: 'Consigli per condividere:',
    inviteTipFriendsFamily: 'Condividi con familiari o amici che conosci già',
    inviteTipMessage: 'Invia il link tramite SMS o e-mail',
    inviteTipCode: 'Usa il codice se il link non si apre direttamente',
    groupSelectorLoadError: 'Impossibile caricare i tuoi gruppi di famiglia e amici. Riprova.',
    groupSelectorEmptyTitle: 'Nessun gruppo trovato',
    groupSelectorEmptyBody: 'Non fai ancora parte di nessun gruppo di famiglia o amici.',
    groupSelectorSelect: 'Seleziona gruppo',
    groupSelectorTitle: 'Seleziona gruppo',
    groupTypeFamily: 'Famiglia',
    groupTypeFriends: 'Amici',
    joinCodeRequired: 'Inserisci un codice o un link.',
    joinFamilySuccess: 'Ti sei unito alla famiglia!',
    joinFriendsSuccess: 'Ti sei unito al gruppo di amici!',
    joinByCodeTitle: 'Unisciti a {{group}} con il codice invito',
    joinByCodeAction: 'Unisciti a {{group}}',
    playAnotherQuizConfirm: 'Sì, inizia una nuova partita',
    playAnotherQuizDecline: 'No, torna alla lobby',
    playAnotherQuizError: 'Impossibile avviare una nuova partita. Riprova.',
    playAnotherQuizFreshStart: 'Nuova partita = nuovo inizio per tutti',
    playAnotherQuizResultsSaved: 'I risultati della partita attuale vengono salvati',
    playAnotherQuizReturnLobby: 'Tutti i giocatori torneranno alla lobby {{roomType}}',
    playAnotherQuizSettingUp: 'Preparazione…',
    playAnotherQuizSubtitle: 'Vuoi iniziare una nuova partita con lo stesso gruppo?',
    playAnotherQuizTitle: 'Giocare un altro quiz?',
    // Italian translations
    tabFamily: 'Famiglia',
    tabFriends: 'Amici',
    tabInvitations: 'Inviti',
    actionAddFamilyMember: 'Aggiungi Membro della Famiglia',
    actionAddFriend: 'Aggiungi Amico',
    actionSendInvitation: 'Invia Invito',
    actionAccept: 'Accetta',
    actionDecline: 'Rifiuta',
    actionRemove: 'Rimuovi',
    actionSearch: 'Cerca',
    placeholderEmailUsername: 'Inserisci email o nome utente',
    labelFamilyMemberName: 'Nome del Membro della Famiglia',
    labelFriendName: 'Nome dell\'Amico',
    messageNoFamilyMembers: 'Nessun membro della famiglia trovato.',
    messageNoFriends: 'Nessun amico trovato.',
    messageNoPendingInvitations: 'Nessun invito in sospeso.',
    messageInvitationSent: 'Invito inviato a {{name}}.',
    messageInvitationAccepted: 'Invito accettato da {{name}}.',
    messageInvitationDeclined: 'Invito rifiutato da {{name}}.',
    messageRemovedSuccessfully: '{{name}} rimosso con successo.',
    messageConfirmRemove: 'Sei sicuro di voler rimuovere {{name}}?',
    titleCreateFamily: 'Crea Famiglia',
    placeholderFamilyName: 'Nome della Famiglia',
    buttonCreate: 'Crea',
    buttonCancel: 'Annulla',
    errorFamilyNameRequired: 'Il nome della famiglia è obbligatorio.',
    errorFamilyLimit: 'Puoi appartenere a un massimo di 3 famiglie. Per favore lascia una famiglia prima di crearne una nuova.',
    titleCreateFriendsGroup: 'Crea Gruppo di Amici',
    placeholderGroupName: 'Nome del Gruppo',
    errorGroupNameRequired: 'Il nome del gruppo è obbligatorio.',
    titleInviteMember: 'Invita Membro',
    labelShareInvite: 'Condividi questo invito:',
    buttonCopyLink: 'Copia Link',
    buttonShareWhatsApp: 'Condividi via WhatsApp',
    labelInviteCode: 'O usa il codice di invito:',
    buttonCopyCode: 'Copia Codice',
    buttonDone: 'Fatto',
    labelPendingInvites: 'Inviti in Sospeso:',
    titleJoinByCode: 'Unisciti alla Famiglia tramite Codice di Invito',
    placeholderInviteCode: 'Inserisci codice di invito...',
    buttonJoinFamily: 'Unisciti alla Famiglia',
    buttonJoining: 'Unendosi...',
    titleFamilyMembers: 'Membri della Famiglia',
    roleOwner: '⭐ Proprietario',
    roleAdmin: '⭐ Amministratore',
    roleMember: 'Membro',
    buttonMakeAdmin: 'Rendi Amministratore',
    buttonClose: 'Chiudi',
    titleFriendsMembers: 'Membri del Gruppo di Amici',
    tabFamilyHub: 'Hub Famiglia',
    tabFriendsHub: 'Hub Amici',
    loadingFamilyHub: 'Caricamento Hub Famiglia...',
    loadingFriendsHub: 'Caricamento Hub Amici...',
    errorLoadingFamily: 'Errore nel caricamento dei dati della famiglia',
    errorLoadingFriends: 'Errore nel caricamento dei dati degli amici',
    buttonRetry: 'Riprova',
    errorLoadingFamilyHub: 'Errore nel caricamento dell\'hub famiglia',
    headerTitle: 'CONNETTITI E CRESCI INSIEME',
    headerSubtitle: 'Costruisci la tua comunità spirituale con famiglia e amici',
    loadingFamilyAndFriendsHub: 'Caricamento Hub Famiglia e Amici',
    emptyStateNotInFamily: 'Non sei ancora in una famiglia.',
    buttonCreateFamily: 'Crea Famiglia',
    buttonJoinByInviteCode: 'Unisciti tramite Codice di Invito',
    buttonViewInvitations: 'Visualizza Inviti ({{count}})',
    sectionTitlePendingInvitations: 'Inviti in Sospeso',
    buttonCreateFamilyOrFriendsGroup: 'Crea Famiglia o Gruppo di Amici',
    alertSuccessInvitationAccepted: 'Invito accettato!',
    alertSuccessInvitationRejected: 'Invito rifiutato.',
    alertErrorInvitationResponse: 'Impossibile rispondere all\'invito.',
    shareInviteMessage: 'Unisciti alla mia famiglia o gruppo di amici su Kingdom Bible Quiz! Tocca questo link: {{url}}',
    alertErrorShareInvite: 'Impossibile condividere il link di invito.',
    alertSuccessCodeCopied: 'Codice famiglia copiato negli appunti.',
    alertSuccessFriendsCodeCopied: 'Codice gruppo amici copiato negli appunti.',
    alertErrorCopyCode: 'Impossibile copiare il codice.',
    alertSuccessLeftFamily: 'Hai lasciato la famiglia.',
    alertSuccessLeftFriendsGroup: 'Hai lasciato il gruppo di amici.',
    alertErrorLeaveFamily: 'Impossibile lasciare la famiglia.',
    alertErrorLeaveFriendsGroup: 'Impossibile lasciare il gruppo di amici.',
    premiumCardFamilyLeaderboard: 'Classifica Famiglia',
    premiumCardFamilyLeaderboardSubtitle: 'Traccia la crescita spirituale della tua famiglia insieme',
    premiumCardFriendsLeaderboard: 'Classifica Amici',
    premiumCardFriendsLeaderboardSubtitle: 'Compete e cresci insieme ai tuoi amici',
    premiumCardComingSoon: 'Prossimamente',
    alertSuccessMemberPromoted: 'Membro promosso ad amministratore!',
    alertErrorPromoteMember: 'Impossibile promuovere il membro.',
    liveScreenNoticeText: 'Cerchi chiese o grandi squadre? Dai un\'occhiata alla scheda Schermo Live per eventi comunitari e funzioni di grandi gruppi.',
    liveScreenNoticeLink: 'Schermo Live',
    
    // Family/Friends Group Cards
    membersLabel: 'Membri',
    statusLabel: 'Stato',
    activeStatus: 'Attivo',
    shareLink: '🔗 Condividi Link',
    copyCode: '📋 Copia Codice',
    viewMembers: '👥 Visualizza Membri',
    leaveFamily: '🚪 Lascia Famiglia',
    leaveGroup: '🚪 Lascia Gruppo',
    enterFamilyLobby: 'Entra nella Lobby Famiglia',
    enterFriendsLobby: 'Entra nella Lobby Amici',
    togetherSubtitle: 'Gioca, condividi e cresci insieme agli altri',
    familyBibleQuiz: 'Quiz Biblico in Famiglia',
    familyQuizSubtitle: 'Impara le Scritture insieme come famiglia',
    startQuiz: 'Inizia il Quiz',
    inviteFamily: 'Invita la Famiglia',
    signInToJoinFamily: 'Accedi per creare o unirti a un gruppo familiare.',
    premiumGroupGateMessage: 'Unisciti a qualsiasi gruppo gratuitamente con un codice di invito. Crea e ospita il tuo con Premium.',
    familyInviteMessage: 'Unisciti alla mia famiglia "{{name}}" su Kingdom Bible Quiz! Usa il codice {{code}} o tocca: {{url}}',
    invalidInviteCode: 'Questo codice di invito non è valido o è scaduto. Controlla il codice e riprova.',
  },
  am: {
    buttonOk: 'እሺ',
    buttonShare: 'አጋራ',
    errorLoadingFriendsHub: 'የጓደኞች ማዕከልን በመጫን ላይ ስህተት ተፈጥሯል',
    invitationFromTo: 'ከ{{sender}} ወደ {{group}} እንዲቀላቀሉ የቀረበ ግብዣ',
    unknown: 'ያልታወቀ',
    group: 'ቡድን',
    titleInviteCode: 'የግብዣ ኮድ',
    messageShareCodeWithFriends: 'ይህን ኮድ ለጓደኞችዎ ያጋሩ፦ {{code}}',
    featureNotImplemented: 'ይህ ባህሪ ገና አልተተገበረም።',
    buttonJoinWithCode: 'በኮድ ተቀላቀል',
    sectionTitleYourFriendsGroups: 'የእርስዎ የጓደኞች ቡድኖች',
    emptyFriendsGroupsTitle: 'እስካሁን የጓደኞች ቡድን የለም',
    emptyFriendsGroupsSubtitle: 'የመጽሐፍ ቅዱስ ጥያቄዎችን በጋራ ለመጫወት የጓደኞች ቡድን ይፍጠሩ ወይም ይቀላቀሉ!',
    inviteCopiedTitle: 'ተቀድቷል!',
    inviteLinkCopied: 'የግብዣ ሊንክ ወደ ክሊፕቦርድ ተቀድቷል',
    inviteCodeCopied: 'የመቀላቀያ ኮድ ወደ ክሊፕቦርድ ተቀድቷል',
    inviteCopyLinkError: 'ሊንኩን መቅዳት አልተቻለም',
    inviteCopyCodeError: 'ኮዱን መቅዳት አልተቻለም',
    inviteShareError: 'ግብዣውን ማጋራት አልተቻለም',
    inviteShareRoomMessage: 'ለቀጣዩ የቤተሰብና የጓደኞች ፈተና የእኛን Kingdom Bible Quiz ክፍል ይቀላቀሉ። ኮድ {{code}} ይጠቀሙ ወይም {{url}} ይክፈቱ',
    inviteShareEventMessage: 'ይህ የክስተት ሊንክ ለቤተ ክርስቲያንና ለትላልቅ ቡድኖች የተለየ የጥያቄ ተሞክሮ ነው፦ {{url}}',
    inviteShareTitle: '{{title}}ን ይቀላቀሉ',
    roomInviteEyebrow: 'የቤተሰብና የጓደኞች ጥያቄ',
    roomInviteTitle: 'ወደ ጥያቄ ክፍል ተጋብዘዋል',
    roomInviteSubtitle: 'በመተግበሪያው ውስጥ ክፍሉን ይቀላቀሉ፣ በጋራ ይጫወቱ፣ እድገትዎን ያመሳስሉ፣ ከቤተሰብና ከጓደኞችዎ ጋር ተገናኝተው ይቆዩ።',
    roomInviteCodeLabel: 'የክፍል ኮድ',
    roomInviteSignedInHint: 'ገብተዋል እና ይህን ክፍል ለመቀላቀል ዝግጁ ነዎት።',
    roomInviteAuthHint: 'ይህን ክፍል ለመቀላቀልና የብዙ ተጫዋች እድገትዎን ለማቆየት ነፃ መለያ ይፍጠሩ ወይም ይግቡ።',
    roomInviteContinue: 'ወደ ጥያቄ ክፍል ተቀላቀል',
    roomInviteJoining: 'ክፍሉን በመቀላቀል ላይ…',
    roomInviteSignIn: 'ግባ ወይም መለያ ፍጠር',
    roomInviteWebHint: 'መተግበሪያው ከተጫነ ይህ ግብዣ እዚያ በራስ-ሰር ይከፈታል።',
    roomInviteInvalidTitle: 'ግብዣው አይገኝም',
    roomInviteInvalidBody: 'ይህ የክፍል ግብዣ ሊንክ ለመቀላቀል የሚያስፈልጉ ዝርዝሮች ይጎድሉታል።',
    roomInviteJoinError: 'ወደዚህ ክፍል እስካሁን መቀላቀል አልተቻለም። እባክዎ የክፍል ኮዱን እንደገና ይሞክሩ።',
    inviteHowToJoin: 'እንዴት መቀላቀል እንደሚቻል፦',
    inviteScanQr: 'ይህን የQR ኮድ በካሜራዎ ይቃኙ',
    inviteEnterCode: 'ወይም የመቀላቀያ ኮዱን ያስገቡ፦ {{code}}',
    inviteTipsTitle: 'የማጋራት ምክሮች፦',
    inviteTipFriendsFamily: 'ከሚያውቋቸው ቤተሰብ ወይም ጓደኞች ጋር ያጋሩ',
    inviteTipMessage: 'ሊንኩን በጽሑፍ መልዕክት ወይም በኢሜይል ይላኩ',
    inviteTipCode: 'ሊንኩ በቀጥታ ካልተከፈተ የመቀላቀያ ኮዱን ይጠቀሙ',
    groupSelectorLoadError: 'የቤተሰብና የጓደኞች ቡድኖችዎን መጫን አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    groupSelectorEmptyTitle: 'ምንም ቡድን አልተገኘም',
    groupSelectorEmptyBody: 'እስካሁን በምንም የቤተሰብ ወይም የጓደኞች ቡድን ውስጥ አይደሉም።',
    groupSelectorSelect: 'ቡድን ይምረጡ',
    groupSelectorTitle: 'ቡድን ይምረጡ',
    groupTypeFamily: 'ቤተሰብ',
    groupTypeFriends: 'ጓደኞች',
    joinCodeRequired: 'እባክዎ ኮድ ወይም ሊንክ ያስገቡ።',
    joinFamilySuccess: 'ቤተሰቡን ተቀላቅለዋል!',
    joinFriendsSuccess: 'የጓደኞች ቡድኑን ተቀላቅለዋል!',
    joinByCodeTitle: 'በግብዣ ኮድ ወደ {{group}} ይቀላቀሉ',
    joinByCodeAction: 'ወደ {{group}} ይቀላቀሉ',
    playAnotherQuizConfirm: 'አዎ፣ አዲስ ጨዋታ ጀምር',
    playAnotherQuizDecline: 'አይ፣ ወደ ሎቢ ተመለስ',
    playAnotherQuizError: 'አዲስ ጨዋታ መጀመር አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    playAnotherQuizFreshStart: 'አዲስ ጨዋታ = ለሁሉም አዲስ ጅምር',
    playAnotherQuizResultsSaved: 'የአሁኑ ጨዋታ ውጤቶች ይቀመጣሉ',
    playAnotherQuizReturnLobby: 'ሁሉም ተጫዋቾች ወደ {{roomType}} ሎቢ ይመለሳሉ',
    playAnotherQuizSettingUp: 'በማዘጋጀት ላይ…',
    playAnotherQuizSubtitle: 'ከተመሳሳይ ቡድን ጋር አዲስ ጨዋታ መጀመር ይፈልጋሉ?',
    playAnotherQuizTitle: 'ሌላ ጥያቄ ይጫወቱ?',
    // Amharic translations
    tabFamily: 'ቤተሰብ',
    tabFriends: 'ጓደኞች',
    tabInvitations: 'ጥሪዎች',
    actionAddFamilyMember: 'የቤተሰብ አባል ጨምር',
    actionAddFriend: 'ጓደኛ ጨምር',
    actionSendInvitation: 'ጥሪ ላክ',
    actionAccept: 'ተቀበል',
    actionDecline: 'ውድቅ አድርግ',
    actionRemove: 'አስወግድ',
    actionSearch: 'ፈልግ',
    placeholderEmailUsername: 'ኢሜይል ወይም የተጠቃሚ ስም አስገባ',
    labelFamilyMemberName: 'የቤተሰብ አባል ስም',
    labelFriendName: 'የጓደኛ ስም',
    messageNoFamilyMembers: 'ምንም የቤተሰብ አባላት አልተገኙም።',
    messageNoFriends: 'ምንም ጓደኞች አልተገኙም።',
    messageNoPendingInvitations: 'ምንም የጥሪ መልዕክቶች የሉም።',
    messageInvitationSent: 'ጥሪ ለ{{name}} ተልኳል።',
    messageInvitationAccepted: 'ጥሪ ከ{{name}} ተቀባይ ተደርጓል።',
    messageInvitationDeclined: 'ጥሪ ከ{{name}} ውድቅ ተደርጓል።',
    messageRemovedSuccessfully: '{{name}} በተሳካ ሁኔታ ተወግዷል።',
    messageConfirmRemove: '{{name}}ን ማስወገድ እንደሚፈልጉ እርግጠኛ ነዎት?',
    titleCreateFamily: 'ቤተሰብ ፍጠር',
    placeholderFamilyName: 'የቤተሰብ ስም',
    buttonCreate: 'ፍጠር',
    buttonCancel: 'ሰርዝ',
    errorFamilyNameRequired: 'የቤተሰብ ስም ያስፈልጋል።',
    errorFamilyLimit: 'እስከ 3 ቤተሰቦች ድረስ አባል መሆን ይችላሉ። አዲስ ቤተሰብ ከመፍጠርዎ በፊት አንዱን ይተዉ።',
    titleCreateFriendsGroup: 'የጓደኞች ቡድን ፍጠር',
    placeholderGroupName: 'የቡድን ስም',
    errorGroupNameRequired: 'የቡድን ስም ያስፈልጋል።',
    titleInviteMember: 'አባል ጋብዝ',
    labelShareInvite: 'ይህንን ጥሪ አካፍል:',
    buttonCopyLink: 'ሊንክ ቅዳ',
    buttonShareWhatsApp: 'በWhatsApp አካፍል',
    labelInviteCode: 'ወይም የጥሪ ኮድ ተጠቀም:',
    buttonCopyCode: 'ኮድ ቅዳ',
    buttonDone: 'ተጠናቅቋል',
    labelPendingInvites: 'የጥሪ መልዕክቶች:',
    titleJoinByCode: 'በጥሪ ኮድ ቤተሰብ ተቀላቀል',
    placeholderInviteCode: 'የጥሪ ኮድ አስገባ...',
    buttonJoinFamily: 'ቤተሰብ ተቀላቀል',
    buttonJoining: 'እየተቀላቀለ...',
    titleFamilyMembers: 'የቤተሰብ አባላት',
    roleOwner: '⭐ ባለቤት',
    roleAdmin: '⭐ አስተዳዳሪ',
    roleMember: 'አባል',
    buttonMakeAdmin: 'አስተዳዳሪ አድርግ',
    buttonClose: 'ዝጋ',
    titleFriendsMembers: 'የጓደኞች ቡድን አባላት',
    tabFamilyHub: 'የቤተሰብ ማዕከል',
    tabFriendsHub: 'የጓደኞች ማዕከል',
    loadingFamilyHub: 'የቤተሰብ ማዕከል እየጫነ...',
    loadingFriendsHub: 'የጓደኞች ማዕከል እየጫነ...',
    errorLoadingFamily: 'የቤተሰብ መረጃ በመጫን ላይ ስህተት',
    errorLoadingFriends: 'የጓደኞች መረጃ በመጫን ላይ ስህተት',
    buttonRetry: 'እንደገና ሞክር',
    errorLoadingFamilyHub: 'የቤተሰብ ማዕከል በመጫን ላይ ስህተት',
    headerTitle: 'ተገናኙ እና አብሮ ያድጉ',
    headerSubtitle: 'ከቤተሰብ እና ጓደኞች ጋር መንፈሳዊ ማህበረሰብዎን ይገንቡ',
    loadingFamilyAndFriendsHub: 'የቤተሰብ እና ጓደኞች ማዕከል እየጫነ',
    emptyStateNotInFamily: 'እስካሁን በቤተሰብ ውስጥ አይደሉም።',
    buttonCreateFamily: 'ቤተሰብ ፍጠር',
    buttonJoinByInviteCode: 'በጥሪ ኮድ ተቀላቀል',
    buttonViewInvitations: 'ጥሪዎችን ይመልከቱ ({{count}})',
    sectionTitlePendingInvitations: 'የጥሪ መልዕክቶች',
    buttonCreateFamilyOrFriendsGroup: 'ቤተሰብ ወይም የጓደኞች ቡድን ፍጠር',
    alertSuccessInvitationAccepted: 'ጥሪ ተቀባይ ተደርጓል!',
    alertSuccessInvitationRejected: 'ጥሪ ውድቅ ተደርጓል።',
    alertErrorInvitationResponse: 'ለጥሪው መመለስ አልተቻለም።',
    shareInviteMessage: 'በKingdom Bible Quiz ላይ ወደ ቤተሰቤ ወይም የጓደኞች ቡድን ተቀላቀሉ! ይህንን ሊንክ ንኩ: {{url}}',
    alertErrorShareInvite: 'የጥሪ ሊንክ ማካፈል አልተቻለም።',
    alertSuccessCodeCopied: 'የቤተሰብ ኮድ ወደ ክሊፕቦርድ ተቀድቷል።',
    alertSuccessFriendsCodeCopied: 'የጓደኞች ቡድን ኮድ ወደ ክሊፕቦርድ ተቀድቷል።',
    alertErrorCopyCode: 'ኮድ መቅዳት አልተቻለም።',
    alertSuccessLeftFamily: 'ቤተሰቡን ለቀዉ።',
    alertSuccessLeftFriendsGroup: 'የጓደኞች ቡድኑን ለቀዉ።',
    alertErrorLeaveFamily: 'ቤተሰቡን መተው አልተቻለም።',
    alertErrorLeaveFriendsGroup: 'የጓደኞች ቡድኑን መተው አልተቻለም።',
    premiumCardFamilyLeaderboard: 'የቤተሰብ ሊደርቦርድ',
    premiumCardFamilyLeaderboardSubtitle: 'የቤተሰብዎን መንፈሳዊ እድገት በጋራ ይከታተሉ',
    premiumCardFriendsLeaderboard: 'የጓደኞች ሊደርቦርድ',
    premiumCardFriendsLeaderboardSubtitle: 'ከጓደኞችዎ ጋር ተወዳደሩ እና አብሮ ያድጉ',
    premiumCardComingSoon: 'በቅርቡ',
    alertSuccessMemberPromoted: 'አባል ወደ አስተዳዳሪነት ከፍ ተደርጓል!',
    alertErrorPromoteMember: 'አባልን ማሳደግ አልተቻለም።',
    liveScreenNoticeText: 'ቤተክርስቲያናት ወይም ትላልቅ ቡድኖች ይፈልጋሉ? ለማህበረሰብ ዝግጅቶች እና የትላልቅ ቡድኖች ባህሪዎች የLive Screen ትራስን ይመልከቱ።',
    liveScreenNoticeLink: 'Live Screen',
    
    // Family/Friends Group Cards
    membersLabel: 'አባላት',
    statusLabel: 'ሁኔታ',
    activeStatus: 'ተካተፍ',
    shareLink: '🔗 ሊንክ አካፍል',
    copyCode: '📋 ኮድ ቀዳ',
    viewMembers: '👥 አባላትን ይመልከቱ',
    leaveFamily: '🚪 ቤተሰብን ተው',
    leaveGroup: '🚪 ቡድንን ተው',
    enterFamilyLobby: 'ወደ የቤተሰብ ሎቢ ይግቡ',
    enterFriendsLobby: 'ወደ የጓደኞች ሎቢ ይግቡ',
    togetherSubtitle: 'ከሌሎች ጋር ይጫወቱ፣ ያካፍሉ እና ያድጉ',
    familyBibleQuiz: 'የቤተሰብ መጽሐፍ ቅዱስ ጥያቄ',
    familyQuizSubtitle: 'እንደ ቤተሰብ አብሮ ቅዱሳት መጻሕፍትን ይማሩ',
    startQuiz: 'ጥያቄ ጀምር',
    inviteFamily: 'ቤተሰብ ጋብዝ',
    signInToJoinFamily: 'የቤተሰብ ቡድን ለመፍጠር ወይም ለመቀላቀል ይግቡ።',
    premiumGroupGateMessage: 'በማንኛውም ቡድን ነፃ ይቀላቀሉ በግብዣ ኮድ። የራስዎን በ Premium ይፍጠሩ እና ያስተናግዱ።',
    familyInviteMessage: 'በ Kingdom Bible Quiz ቤተሰቤን "{{name}}" ተቀላቀሉ! ኮድ {{code}} ተጠቀሙ ወይም ይንኩ: {{url}}',
    invalidInviteCode: 'ይህ የግብዣ ኮድ ልክ አይደለም ወይም ጊዜው አልፏል። ኮዱን ያረጋግጡና እንደገና ይሞክሩ።',
  },
  ko: {
    buttonOk: '확인',
    buttonShare: '공유',
    errorLoadingFriendsHub: '친구 허브를 불러오는 중 오류가 발생했습니다',
    invitationFromTo: '{{sender}}님이 {{group}}에 초대했습니다',
    unknown: '알 수 없음',
    group: '그룹',
    titleInviteCode: '초대 코드',
    messageShareCodeWithFriends: '친구들에게 이 코드를 공유하세요: {{code}}',
    featureNotImplemented: '이 기능은 아직 제공되지 않습니다.',
    buttonJoinWithCode: '코드로 참여',
    sectionTitleYourFriendsGroups: '내 친구 그룹',
    emptyFriendsGroupsTitle: '아직 친구 그룹이 없습니다',
    emptyFriendsGroupsSubtitle: '친구 그룹을 만들거나 참여해 함께 성경 퀴즈를 즐겨 보세요!',
    inviteCopiedTitle: '복사됨!',
    inviteLinkCopied: '초대 링크가 클립보드에 복사되었습니다',
    inviteCodeCopied: '참여 코드가 클립보드에 복사되었습니다',
    inviteCopyLinkError: '링크를 복사하지 못했습니다',
    inviteCopyCodeError: '코드를 복사하지 못했습니다',
    inviteShareError: '초대를 공유하지 못했습니다',
    inviteShareRoomMessage: '다음 가족·친구 도전을 위해 Kingdom Bible Quiz 방에 참여하세요. 코드 {{code}} 를 사용하거나 {{url}} 을 여세요',
    inviteShareEventMessage: '이 이벤트 링크는 교회 및 대규모 그룹을 위한 별도의 퀴즈 경험용입니다: {{url}}',
    inviteShareTitle: '{{title}} 참여하기',
    roomInviteEyebrow: '가족·친구 퀴즈',
    roomInviteTitle: '퀴즈 방에 초대받았습니다',
    roomInviteSubtitle: '앱에서 방에 참여해 함께 플레이하고, 진행 상황을 동기화하고, 가족·친구와 계속 연결되세요.',
    roomInviteCodeLabel: '방 코드',
    roomInviteSignedInHint: '로그인되어 있어 이 방에 바로 참여할 수 있습니다.',
    roomInviteAuthHint: '무료 계정을 만들거나 로그인하여 이 방에 참여하고 멀티플레이 진행 상황을 유지하세요.',
    roomInviteContinue: '퀴즈 방 참여',
    roomInviteJoining: '방에 참여하는 중…',
    roomInviteSignIn: '로그인 또는 계정 만들기',
    roomInviteWebHint: '앱이 이미 설치되어 있다면 이 초대가 앱에서 자동으로 열립니다.',
    roomInviteInvalidTitle: '초대를 사용할 수 없습니다',
    roomInviteInvalidBody: '이 초대 링크에는 참여에 필요한 정보가 없습니다.',
    roomInviteJoinError: '아직 이 방에 참여할 수 없습니다. 방 코드로 다시 시도해 주세요.',
    inviteHowToJoin: '참여 방법:',
    inviteScanQr: '카메라로 이 QR 코드를 스캔하세요',
    inviteEnterCode: '또는 참여 코드를 입력하세요: {{code}}',
    inviteTipsTitle: '공유 팁:',
    inviteTipFriendsFamily: '이미 알고 있는 가족이나 친구와 공유하세요',
    inviteTipMessage: '문자 메시지나 이메일로 링크를 보내세요',
    inviteTipCode: '링크가 바로 열리지 않으면 참여 코드를 사용하세요',
    groupSelectorLoadError: '가족 및 친구 그룹을 불러오지 못했습니다. 다시 시도해 주세요.',
    groupSelectorEmptyTitle: '그룹을 찾을 수 없습니다',
    groupSelectorEmptyBody: '아직 가입한 가족 또는 친구 그룹이 없습니다.',
    groupSelectorSelect: '그룹 선택',
    groupSelectorTitle: '그룹 선택',
    groupTypeFamily: '가족',
    groupTypeFriends: '친구',
    joinCodeRequired: '코드 또는 링크를 입력해 주세요.',
    joinFamilySuccess: '가족에 참여했습니다!',
    joinFriendsSuccess: '친구 그룹에 참여했습니다!',
    joinByCodeTitle: '초대 코드로 {{group}} 참여',
    joinByCodeAction: '{{group}} 참여',
    playAnotherQuizConfirm: '네, 새 게임 시작',
    playAnotherQuizDecline: '아니요, 로비로 돌아가기',
    playAnotherQuizError: '새 게임을 시작하지 못했습니다. 다시 시도해 주세요.',
    playAnotherQuizFreshStart: '새 게임 = 모두 새로 시작',
    playAnotherQuizResultsSaved: '현재 게임 결과는 저장됩니다',
    playAnotherQuizReturnLobby: '모든 플레이어가 {{roomType}} 로비로 돌아갑니다',
    playAnotherQuizSettingUp: '설정 중…',
    playAnotherQuizSubtitle: '같은 그룹으로 새 게임을 시작할까요?',
    playAnotherQuizTitle: '퀴즈를 한 번 더 할까요?',
    // Korean translations
    tabFamily: '가족',
    tabFriends: '친구들',
    tabInvitations: '초대장',
    actionAddFamilyMember: '가족 구성원 추가',
    actionAddFriend: '친구 추가',
    actionSendInvitation: '초대장 보내기',
    actionAccept: '수락',
    actionDecline: '거절',
    actionRemove: '제거',
    actionSearch: '검색',
    placeholderEmailUsername: '이메일 또는 사용자 이름 입력',
    labelFamilyMemberName: '가족 구성원 이름',
    labelFriendName: '친구 이름',
    messageNoFamilyMembers: '가족 구성원을 찾을 수 없습니다.',
    messageNoFriends: '친구를 찾을 수 없습니다.',
    messageNoPendingInvitations: '대기 중인 초대장이 없습니다.',
    messageInvitationSent: '{{name}}에게 초대장을 보냈습니다.',
    messageInvitationAccepted: '{{name}}의 초대장을 수락했습니다.',
    messageInvitationDeclined: '{{name}}의 초대장을 거절했습니다.',
    messageRemovedSuccessfully: '{{name}}을(를) 성공적으로 제거했습니다.',
    messageConfirmRemove: '{{name}}을(를) 제거하시겠습니까?',
    titleCreateFamily: '가족 만들기',
    placeholderFamilyName: '가족 이름',
    buttonCreate: '만들기',
    buttonCancel: '취소',
    errorFamilyNameRequired: '가족 이름이 필요합니다.',
    errorFamilyLimit: '최대 3개의 가족에 속할 수 있습니다. 새 가족을 만들기 전에 하나를 떠나세요.',
    titleCreateFriendsGroup: '친구 그룹 만들기',
    placeholderGroupName: '그룹 이름',
    errorGroupNameRequired: '그룹 이름이 필요합니다.',
    titleInviteMember: '구성원 초대',
    labelShareInvite: '이 초대장 공유:',
    buttonCopyLink: '링크 복사',
    buttonShareWhatsApp: 'WhatsApp으로 공유',
    labelInviteCode: '또는 초대 코드 사용:',
    buttonCopyCode: '코드 복사',
    buttonDone: '완료',
    labelPendingInvites: '대기 중인 초대장:',
    titleJoinByCode: '초대 코드로 가족 참여',
    placeholderInviteCode: '초대 코드 입력...',
    buttonJoinFamily: '가족 참여',
    buttonJoining: '참여 중...',
    titleFamilyMembers: '가족 구성원',
    roleOwner: '⭐ 소유자',
    roleAdmin: '⭐ 관리자',
    roleMember: '구성원',
    buttonMakeAdmin: '관리자로 만들기',
    buttonClose: '닫기',
    titleFriendsMembers: '친구 그룹 구성원',
    tabFamilyHub: '가족 허브',
    tabFriendsHub: '친구 허브',
    loadingFamilyHub: '가족 허브 로딩 중...',
    loadingFriendsHub: '친구 허브 로딩 중...',
    errorLoadingFamily: '가족 데이터 로딩 오류',
    errorLoadingFriends: '친구 데이터 로딩 오류',
    buttonRetry: '다시 시도',
    errorLoadingFamilyHub: '가족 허브 로딩 오류',
    headerTitle: '연결하고 함께 성장하세요',
    headerSubtitle: '가족과 친구들과 함께 영적 공동체를 구축하세요',
    loadingFamilyAndFriendsHub: '가족과 친구 허브 로딩 중',
    emptyStateNotInFamily: '아직 가족에 속해 있지 않습니다.',
    buttonCreateFamily: '가족 만들기',
    buttonJoinByInviteCode: '초대 코드로 참여',
    buttonViewInvitations: '초대장 보기 ({{count}})',
    sectionTitlePendingInvitations: '대기 중인 초대장',
    buttonCreateFamilyOrFriendsGroup: '가족 또는 친구 그룹 만들기',
    alertSuccessInvitationAccepted: '초대장이 수락되었습니다!',
    alertSuccessInvitationRejected: '초대장이 거절되었습니다.',
    alertErrorInvitationResponse: '초대장에 응답하지 못했습니다.',
    shareInviteMessage: 'Kingdom Bible Quiz에서 내 가족이나 친구 그룹에 참여하세요! 이 링크를 탭하세요: {{url}}',
    alertErrorShareInvite: '초대 링크 공유에 실패했습니다.',
    alertSuccessCodeCopied: '가족 코드가 클립보드에 복사되었습니다.',
    alertSuccessFriendsCodeCopied: '친구 그룹 코드가 클립보드에 복사되었습니다.',
    alertErrorCopyCode: '코드를 복사할 수 없습니다.',
    alertSuccessLeftFamily: '가족을 떠났습니다.',
    alertSuccessLeftFriendsGroup: '친구 그룹을 떠났습니다.',
    alertErrorLeaveFamily: '가족을 떠나지 못했습니다.',
    alertErrorLeaveFriendsGroup: '친구 그룹을 떠나지 못했습니다.',
    premiumCardFamilyLeaderboard: '가족 리더보드',
    premiumCardFamilyLeaderboardSubtitle: '가족의 영적 성장을 함께 추적하세요',
    premiumCardFriendsLeaderboard: '친구 리더보드',
    premiumCardFriendsLeaderboardSubtitle: '친구들과 경쟁하고 함께 성장하세요',
    premiumCardComingSoon: '곧 출시',
    alertSuccessMemberPromoted: '구성원이 관리자로 승진했습니다!',
    alertErrorPromoteMember: '구성원 승진에 실패했습니다.',
    liveScreenNoticeText: '교회나 큰 팀을 찾고 계신가요? 커뮤니티 이벤트와 대규모 그룹 기능을 위해 라이브 스크린 탭을 확인하세요.',
    liveScreenNoticeLink: '라이브 스크린',
    
    // Family/Friends Group Cards
    membersLabel: '구성원',
    statusLabel: '상태',
    activeStatus: '활성',
    shareLink: '🔗 링크 공유',
    copyCode: '📋 코드 복사',
    viewMembers: '👥 구성원 보기',
    leaveFamily: '🚪 가족 떠나기',
    leaveGroup: '🚪 그룹 떠나기',
    enterFamilyLobby: '가족 로비 입장',
    enterFriendsLobby: '친구 로비 입장',
    togetherSubtitle: '다른 사람들과 함께 플레이하고, 나누고, 성장하세요',
    familyBibleQuiz: '가족 성경 퀴즈',
    familyQuizSubtitle: '가족과 함께 성경을 배워보세요',
    startQuiz: '퀴즈 시작',
    inviteFamily: '가족 초대',
    signInToJoinFamily: '가족 그룹을 만들거나 참여하려면 로그인하세요.',
    premiumGroupGateMessage: '초대 코드로 무료로 그룹에 참여하세요. 프리미엄으로 직접 만들고 호스트하세요.',
    familyInviteMessage: 'Kingdom Bible Quiz에서 내 가족 "{{name}}"에 참여하세요! 코드 {{code}}를 사용하거나 탭하세요: {{url}}',
    invalidInviteCode: '이 초대 코드는 유효하지 않거나 만료되었습니다. 코드를 확인하고 다시 시도하세요.',
  },
};
